<template>
  <div class="amazon_edit" style="width: 90%">
    <input
      v-show="false"
      type="file"
      id="fileUpload"
      name="file"
      @change="handleSaveFile"
    />
    <div class="main">
      <el-form ref="basicForm" label-width="200px" :model="basicForm">
        <div id="basic" class="basic">
          <div class="title">基础信息</div>
          <el-form-item
            prop="templateName"
            :rules="[
              { required: true, message: '请输入内容', trigger: 'blur' },
            ]"
            label="模板名称："
          >
            <el-input
              :disabled="templateId.length > 0"
              size="mini"
              v-model="basicForm.templateName"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="designId || pId || remitId"
            prop="quantity"
            label=""
          >
            <el-button
              size="small"
              type="primary"
              @click="priceConfigVisible = true"
              >指定颜色、尺码汇出</el-button
            >
            <el-button
              size="small"
              type="primary"
              @click="sizeColorVisible = true"
              >颜色、尺码名称自定义</el-button
            >
          </el-form-item>
          <el-form-item
            :rules="[
              { required: true, message: '请输入内容', trigger: 'blur' },
            ]"
            v-if="upload != '1'"
            prop="picRemitMode"
            label="图片汇出方式："
          >
            <el-radio-group v-model="basicForm.picRemitMode">
              <template v-for="record in dictData['picRemitMode']">
                <el-radio :label="record.value" :key="record.value">
                  {{ record.label }}</el-radio
                >
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            v-if="basicForm.picRemitMode == '01'"
            :rules="[
              { required: true, message: '请输入内容', trigger: 'blur' },
            ]"
            prop="productPicAddr"
            label="同步产品图片地址："
          >
            <el-select
              clearable
              style="width: 100%"
              size="mini"
              v-model="basicForm.productPicAddr"
              placeholder="请选择产品图片地址"
            >
              <el-option
                v-for="(record, index) in pictureAddresses"
                :key="index"
                :label="record"
                :value="record"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="图片分辨率设置：">
            <div style="position: relative">
              <div
                style="
                  display: inline-block;
                  margin: 0 0 0 8px;
                  position: relative;
                "
                @click="showPicSize = true"
              >
                <span style="right: 10px; top: -2px; color: #4934b2">
                  <span class="size_name_style is_main active"
                    ><span
                      ><i
                        class="el-icon-full-screen"
                        style="margin: 0 4px 0 0"
                      ></i
                      >尺寸调整（{{ basicForm.picSizeW }} x
                      {{ basicForm.picSizeH }}px）
                      <i
                        class="icon-screen_low f14 pa"
                        style="top: 0px; right: -14px"
                      ></i>
                    </span>
                  </span>
                </span>
              </div>
              <div
                v-if="showPicSize"
                style="
                  position: absolute;
                  left: 0px;
                  top: 39px;
                  z-index: 100;
                  padding: 8px;
                "
                class="imgSize-box active is_main"
              >
                <div class="cont">
                  <el-radio-group style="display: block" v-model="sizeConfig">
                    <el-radio
                      style="display: block; margin: 16px 0"
                      :label="1600"
                      >1600 x 1600px(默认)</el-radio
                    >
                    <el-radio
                      style="display: block; margin: 16px 0"
                      :label="800"
                      >800 x 800px</el-radio
                    >
                    <el-radio
                      style="display: block; margin: 16px 0"
                      :label="1200"
                      >1200 x 1200px</el-radio
                    >
                    <el-radio
                      style="display: block; margin: 16px 0"
                      :label="2000"
                      >2000 x 2000px</el-radio
                    >
                    <el-radio
                      style="display: block; margin: 16px 0 0 0"
                      :label="0"
                      >自定义</el-radio
                    >
                  </el-radio-group>
                  <div v-if="sizeConfig == 0">
                    <input
                      placeholder="宽度"
                      v-model="picSizeW"
                      style="width: 60px; line-height: 24px; margin: 0 16px 0 0"
                    />
                    x
                    <input
                      v-model="picSizeH"
                      placeholder="高度"
                      style="width: 60px; line-height: 24px"
                    />
                  </div>
                </div>
                <div class="foot" style="text-align: center">
                  <el-button @click="showPicSize = false" size="small"
                    >取消</el-button
                  >
                  <el-button
                    size="small"
                    @click="handleSavePicSize"
                    type="primary"
                    >保存</el-button
                  >
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item
            v-if="
              (platName == 'lazada' ||
                platName == 'shopee' ||
                platName == 'tiktok') &&
                designId
            "
            prop="saleForm"
            label="售卖形式:"
            :rules="[
              { required: true, message: '请输入内容', trigger: 'change' },
            ]"
          >
            <el-radio
              style="margin-right:4px;"
              v-model="basicForm.saleForm"
              label="01"
              >多颜色
            </el-radio>
            <el-tooltip
              class="item"
              effect="dark"
              content="汇出或上传时，1个主体多颜色变体展示，例：1个产品多个颜色切换"
              placement="top"
            >
              <i style="margin-right:18px;" class="el-icon-question"></i>
            </el-tooltip>

            <el-radio
              style="margin-right:4px;"
              v-model="basicForm.saleForm"
              label="02"
              >单颜色
            </el-radio>
            <el-tooltip
              class="item"
              effect="dark"
              content="汇出或上传时，多颜色产品展示，例：红色产品、蓝色产品等"
              placement="top"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
          </el-form-item>
        </div>
      </el-form>

      <div id="template" class="title">属性信息</div>
      <div v-if="platNo == '09'">
        <el-dropdown @command="handleCommand">
          <el-button size="small" type="primary">
            添加属性<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              :command="index"
              v-for="(record, index) in attrList"
              :key="index"
              >{{ record.attrName }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div>
        <el-form :ref="`form$`" :model="formRequire" label-width="200px">
          <div class="basic">
            <div v-if="platNo != '09'" class="form-title">
              必填项
            </div>
            <div class="form-content">
              <el-form-item
                v-for="(item, number) of dataRequire"
                :label="item.attrName + '：'"
                :key="number"
                :prop="item.attrName"
                v-if="item.showAttr"
              >
                <div class="form-label" slot="label">
                  <div
                    :title="item.attrName"
                    style="width: 176px"
                    class="text-ellipsis"
                  >
                    <span style="color:red;">*</span> {{ item.attrName }}：
                  </div>
                </div>
                <div v-if="item.attrName == 'Category' && platNo == '05'">
                  <el-select
                    clearable
                    filterable
                    v-model="formRequire[item.attrId]"
                    placeholder="请选择"
                    class="input"
                    size="small"
                    @change="handleChangeShopeeCategory"
                  >
                    <el-option
                      v-for="(value, index) in dictData['shopeeCategory']"
                      :key="index"
                      :label="value.label"
                      :value="value.value"
                    >
                    </el-option>
                  </el-select>
                  <div
                    :title="item.attrDesc"
                    style="float:left;"
                    class="text-ellipsis field-name"
                  >
                    {{ item.attrDesc }}
                  </div>
                </div>
                <div v-else-if="item.attrName == 'catId' && platNo == '03'">
                  <el-cascader
                    v-model="formRequire[item.attrId]"
                    :props="catSelectProps"
                    :options="catOptions"
                    size="small"
                    :show-all-levels="false"
                    filterable
                    :filter-method="dataFilter"
                    @change="handleChangeLazadaCategory"
                  ></el-cascader>

                  <span
                    @click="categoryVisible = true"
                    style="color:#4934b2;cursor:pointer;margin: 0 0 0 20px;"
                    >参考分类</span
                  >

                  <div
                    :title="item.attrDesc"
                    style="float:left;"
                    class="text-ellipsis field-name"
                  >
                    {{ item.attrDesc }}
                  </div>
                </div>

                <div v-else-if="item.attrName == 'Brand' && platNo == '03'">
                  <el-select
                    clearable
                    filterable
                    v-model="formRequire[item.attrId]"
                    placeholder="请选择"
                    class="input"
                    size="small"
                  >
                    <el-option
                      v-for="(value, index) in brandListLazada"
                      :key="index"
                      :label="value.name"
                      :value="value.brand_id.toString()"
                    >
                    </el-option>
                  </el-select>
                  <div
                    :title="item.attrDesc"
                    style="float:left;"
                    class="text-ellipsis field-name"
                  >
                    {{ item.attrDesc }}
                  </div>
                </div>
                <div v-else-if="item.attrName == 'Warranty' && platNo == '03'">
                  <el-select
                    clearable
                    filterable
                    v-model="formRequire[item.attrId]"
                    placeholder="请选择"
                    class="input"
                    size="small"
                  >
                    <el-option
                      v-for="(value, index) in warrantyList"
                      :key="index"
                      :label="value.name"
                      :value="value.name"
                    >
                    </el-option>
                  </el-select>
                  <div
                    :title="item.attrDesc"
                    style="float:left;"
                    class="text-ellipsis field-name"
                  >
                    {{ item.attrDesc }}
                  </div>
                </div>
                <div
                  v-else-if="item.attrName == 'Warranty Type' && platNo == '03'"
                >
                  <el-select
                    clearable
                    filterable
                    v-model="formRequire[item.attrId]"
                    placeholder="请选择"
                    class="input"
                    size="small"
                  >
                    <el-option
                      v-for="(value, index) in warrantyTypeList"
                      :key="index"
                      :label="value.name"
                      :value="value.name"
                    >
                    </el-option>
                  </el-select>
                  <div
                    :title="item.attrDesc"
                    style="float:left;"
                    class="text-ellipsis field-name"
                  >
                    {{ item.attrDesc }}
                  </div>
                </div>
                <div v-else-if="item.attrName == 'Category' && platNo == '10'">
                  <el-cascader
                    v-model="formRequire[item.attrId]"
                    :props="treeSelectProps"
                    :options="categoryList"
                    size="small"
                    :show-all-levels="false"
                    filterable
                    :filter-method="dataFilter"
                    @change="handleChangeCategory"
                  ></el-cascader>
                  <div
                    :title="item.attrDesc"
                    style="float:left;"
                    class="text-ellipsis field-name"
                  >
                    {{ item.attrDesc }}
                  </div>
                </div>

                <div
                  v-else-if="
                    item.attrName == 'Product Description' && platNo == '05'
                  "
                >
                  <CKEditor4
                    class="editor"
                    v-model="formRequire[item.attrId]"
                    @getCkEditorInstance="getEditor"
                    :config="editorConfig"
                    @open="openUploadDialog"
                  ></CKEditor4>
                  <div
                    :title="item.attrDesc"
                    style="    bottom: -23px;top: inherit;"
                    class="text-ellipsis field-name"
                  >
                    {{ item.attrDesc }}
                  </div>
                </div>

                <div
                  v-else-if="
                    item.attrName == 'Product Description' && platNo == '10'
                  "
                >
                  <CKEditor4
                    class="editor"
                    v-model="formRequire[item.attrId]"
                    @getCkEditorInstance="getEditor"
                    :config="editorConfig"
                    @open="openUploadDialog"
                  ></CKEditor4>
                  <div
                    :title="item.attrDesc"
                    style="    bottom: -23px;top: inherit;"
                    class="text-ellipsis field-name"
                  >
                    {{ item.attrDesc }}
                  </div>
                  <div
                    class="add-image-button-editor"
                    style="    left: 826px; width: 200px;    top: -8px;position: absolute;color: #4934b2;font-size:14px;"
                  >
                    <p>插入图片</p>
                    <div class="variable-select-box">
                      <ul class="variable-pick-ul">
                        <li
                          @click="handleAddSampleDesc(item, record)"
                          v-for="record in imageSamplesDesc"
                          :key="record"
                        >
                          效果图{{ record }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div v-else-if="item.attrName == 'Brand Id' && platNo == '10'">
                  <el-select
                    clearable
                    filterable
                    v-model="formRequire[item.attrId]"
                    placeholder="请选择"
                    class="input"
                    size="small"
                  >
                    <el-option
                      v-for="(value, index) in brandList"
                      :key="index"
                      :label="value.name"
                      :value="value.id"
                    >
                    </el-option>
                  </el-select>
                  <div
                    :title="item.attrDesc"
                    style="float:left;"
                    class="text-ellipsis field-name"
                  >
                    {{ item.attrDesc }}
                  </div>
                </div>

                <div v-else-if="item.attrName == 'Warehouse Id'">
                  <el-select
                    clearable
                    filterable
                    v-model="formRequire[item.attrId]"
                    placeholder="请选择"
                    class="input"
                    size="small"
                  >
                    <el-option
                      v-for="(value, index) in warehouses"
                      :key="index"
                      :label="value.warehouse_name"
                      :value="value.warehouse_id"
                    >
                    </el-option>
                  </el-select>
                  <div
                    :title="item.attrDesc"
                    style="float:left;"
                    class="text-ellipsis field-name"
                  >
                    {{ item.attrDesc }}
                  </div>
                </div>

                <div v-else-if="item.dataType == '02'">
                  <el-select
                    clearable
                    filterable
                    v-model="formRequire[item.attrId]"
                    placeholder="请选择"
                    class="input"
                    size="small"
                  >
                    <el-option
                      v-for="(value, index) in item.attrOptions"
                      :key="index"
                      :label="value.valName"
                      :value="value.valId"
                    >
                    </el-option>
                  </el-select>
                  <div
                    :title="item.attrDesc"
                    style="float:left;"
                    class="text-ellipsis field-name"
                  >
                    {{ item.attrDesc }}
                  </div>
                </div>
                <div
                  v-else-if="item.attrName == 'Product Name' && platNo == '05'"
                >
                  <el-input
                    style="float:left;width: 499px !important"
                    :readonly="
                      item.attrName == 'Color' ||
                      item.attrName == 'Size' ||
                      item.attrName == 'Option for Variation 1' ||
                      item.attrName == 'Option for Variation 2' ||
                      item.attrName == 'SKU Value 1' ||
                      item.attrName == 'SKU Value 2'
                        ? true
                        : false
                    "
                    :id="`input_${item.attrId}`"
                    :ref="`input_${item.attrId}`"
                    placeholder="请输入内容"
                    v-model="formRequire[item.attrId]"
                    show-word-limit
                    maxlength="100"
                    type="text"
                    size="small"
                  ></el-input>
                  <div
                    v-if="
                      item.attrName != 'Color' &&
                        item.attrName != 'Size' &&
                        item.attrName != 'Option for Variation 1' &&
                        item.attrName != 'Option for Variation 2' &&
                        item.attrName != 'SKU Value 1' &&
                        item.attrName != 'SKU Value 2' &&
                        item.var
                    "
                    style="float:left;margin: 0 0 0 20px;position:relative;"
                    class="variable-insert"
                  >
                    <div class="insert-link">
                      插入变量
                      <div class="variable-select-menu">
                        <ul>
                          <li
                            class="variable-select-box-text"
                            :key="number"
                            v-for="(record, number) in varList"
                            @click="
                              handleInsertVariable(
                                formRequire,
                                item.attrId,
                                record.var
                              )
                            "
                          >
                            {{ record.name }}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <i
                      @mouseenter="handleShowVarHelp"
                      @mouseout="showVarHelp = false"
                      class="el-icon-question"
                    ></i>
                  </div>
                  <div style="float:left;margin: 0 0 0 16px;">
                    <el-button
                      @click="handleShowTermDialog"
                      type="primary"
                      size="small"
                      >自动生成</el-button
                    ><span
                      v-if="templateInfo"
                      style="position:absolute;right: -70px;color:red;margin: 0 0 0 4px;"
                      >已选模板<i
                        style="cursor:pointer;"
                        @click="handleDeleteTemplateInfo"
                        class="el-icon-close"
                      ></i
                    ></span>
                  </div>
                  <div
                    :title="item.attrDesc"
                    style="float:left;"
                    class="text-ellipsis field-name"
                  >
                    {{ item.attrDesc }}
                  </div>
                </div>

                <div v-else-if="item.attrName == 'Product Name'">
                  <el-input
                    style="float:left;width: 499px !important"
                    :readonly="
                      item.attrName == 'Color' ||
                      item.attrName == 'Size' ||
                      item.attrName == 'Option for Variation 1' ||
                      item.attrName == 'Option for Variation 2' ||
                      item.attrName == 'SKU Value 1' ||
                      item.attrName == 'SKU Value 2'
                        ? true
                        : false
                    "
                    :id="`input_${item.attrId}`"
                    :ref="`input_${item.attrId}`"
                    placeholder="请输入内容"
                    v-model="formRequire[item.attrId]"
                    show-word-limit
                    maxlength="255"
                    type="text"
                    size="small"
                  ></el-input>
                  <div
                    v-if="
                      item.attrName != 'Color' &&
                        item.attrName != 'Size' &&
                        item.attrName != 'Option for Variation 1' &&
                        item.attrName != 'Option for Variation 2' &&
                        item.attrName != 'SKU Value 1' &&
                        item.attrName != 'SKU Value 2' &&
                        item.var
                    "
                    style="float:left;margin: 0 0 0 20px;position:relative;"
                    class="variable-insert"
                  >
                    <div class="insert-link">
                      插入变量
                      <div class="variable-select-menu">
                        <ul>
                          <li
                            class="variable-select-box-text"
                            :key="number"
                            v-for="(record, number) in varList"
                            @click="
                              handleInsertVariable(
                                formRequire,
                                item.attrId,
                                record.var
                              )
                            "
                          >
                            {{ record.name }}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <i
                      @mouseenter="handleShowVarHelp"
                      @mouseout="showVarHelp = false"
                      class="el-icon-question"
                    ></i>
                  </div>
                  <div style="float:left;margin: 0 0 0 16px;">
                    <el-button
                      @click="handleShowTermDialog"
                      type="primary"
                      size="small"
                      >自动生成</el-button
                    ><span
                      v-if="templateInfo"
                      style="position:absolute;right: -70px;color:red;margin: 0 0 0 4px;"
                      >已选模板
                      <i
                        style="cursor:pointer;"
                        @click="handleDeleteTemplateInfo"
                        class="el-icon-close"
                      ></i
                    ></span>
                  </div>
                  <div
                    :title="item.attrDesc"
                    style="float:left;"
                    class="text-ellipsis field-name"
                  >
                    {{ item.attrDesc }}
                  </div>
                </div>

                <div v-else-if="item.dataType == '01'">
                  <el-input
                    style="float:left;width: 499px !important"
                    :readonly="
                      item.attrName == 'Color' ||
                      item.attrName == 'Size' ||
                      item.attrName == 'Option for Variation 1' ||
                      item.attrName == 'Option for Variation 2' ||
                      item.attrName == 'SKU Value 1' ||
                      item.attrName == 'SKU Value 2'
                        ? true
                        : false
                    "
                    :id="`input_${item.attrId}`"
                    :ref="`input_${item.attrId}`"
                    placeholder="请输入内容"
                    v-model="formRequire[item.attrId]"
                    show-word-limit
                    type="text"
                    size="small"
                  ></el-input>
                  <div
                    v-if="
                      item.attrName != 'Color' &&
                        item.attrName != 'Size' &&
                        item.attrName != 'Option for Variation 1' &&
                        item.attrName != 'Option for Variation 2' &&
                        item.attrName != 'SKU Value 1' &&
                        item.attrName != 'SKU Value 2' &&
                        item.var
                    "
                    style="float:left;margin: 0 0 0 20px;position:relative;"
                    class="variable-insert"
                  >
                    <div class="insert-link">
                      插入变量
                      <div class="variable-select-menu">
                        <ul>
                          <li
                            class="variable-select-box-text"
                            :key="number"
                            v-for="(record, number) in varList"
                            @click="
                              handleInsertVariable(
                                formRequire,
                                item.attrId,
                                record.var
                              )
                            "
                          >
                            {{ record.name }}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <i
                      @mouseenter="handleShowVarHelp"
                      @mouseout="showVarHelp = false"
                      class="el-icon-question"
                    ></i>
                  </div>
                  <div
                    :title="item.attrDesc"
                    style="float:left;"
                    class="text-ellipsis field-name"
                  >
                    {{ item.attrDesc }}
                  </div>
                </div>

                <ul
                  v-else-if="item.dataType == '08'"
                  class="extra-image-ul letter w70 detail-image-ul amazon sort-img active"
                >
                  <draggable
                    :list="item.imageGroup"
                    style="overflow: hidden; display: inline-block"
                    filter=".forbid"
                    @start="drag = true"
                    @end="drag = false"
                    :move="onMove"
                  >
                    <li
                      v-for="(record, index) in item.imageGroup"
                      :key="index"
                      class="sort-img-item"
                      :class="index === 0 ? 'forbid' : ''"
                    >
                      <div
                        @click="handleDeleteImage(item)"
                        v-if="record.isMain"
                        class="item-badge"
                      >
                        删除
                      </div>
                      <p v-if="record.imageUrl.indexOf('http') === -1">
                        效果图{{ record.imageUrl }}
                      </p>
                      <img v-else :src="record.imageUrl" />
                      <span class="first-pro-icon icon-corner-mark"></span>
                    </li>
                  </draggable>
                  <li
                    class="forbid"
                    :class="{ 'add-image-button': true }"
                    v-if="item.imageGroup.length < 1"
                  >
                    <p><i class="el-icon-plus"></i></p>
                    <div class="variable-select-box">
                      <ul>
                        <li>
                          插入变量
                          <ul class="variable-pick-ul">
                            <li
                              @click="handleAddSample(item, record, '1')"
                              v-for="record in imageSamples"
                              :key="record"
                            >
                              效果图{{ record }}
                            </li>
                          </ul>
                        </li>
                        <li @click="handleUploadImage(item)">本地图片</li>
                      </ul>
                    </div>
                  </li>
                  <div
                    v-if="item.attrName == 'Image per Variation'"
                    style="position:absolute;left: 119px;top: -4px;color: #606266;font-size:13px;"
                  >
                    mainPicColor：
                    <el-select
                      size="small"
                      v-model="mainPicColor"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in mainPicColorOptions"
                        :key="item.sysName"
                        :value="item.sysName"
                      >
                        {{ item.sysName
                        }}<span v-if="dictMap['language'][item.sysName]"
                          >（{{ dictMap["language"][item.sysName] }}）</span
                        >
                      </el-option>
                    </el-select>
                    <div style="color: #aaaaaa;margin: -8px 0 0 100px;">
                      首张主图颜色
                    </div>
                  </div>
                  <div
                    v-if="item.attrDesc"
                    style="float:left;top: 106px;"
                    class="text-ellipsis field-name"
                  >
                    {{ item.attrDesc }}
                  </div>
                </ul>
              </el-form-item>
            </div>
          </div>
          <div v-if="attributeList.length > 0">
            <div class="form-title">
              属性信息
            </div>
            <div class="form-content">
              <el-row class="category-inputs" :gutter="20">
                <el-col
                  v-for="(item, number) in attributeList"
                  :key="number"
                  :span="12"
                >
                  <el-form-item>
                    <div class="form-label" slot="label">
                      <div
                        :title="item.label"
                        style="width: 176px"
                        class="text-ellipsis"
                      >
                        <span v-if="item.is_mandatory" style="color:red;"
                          >*</span
                        >
                        {{ item.label }}：
                      </div>
                    </div>
                    <el-input
                      v-if="
                        item.input_type == 'text' ||
                          item.input_type == 'numeric' ||
                          item.input_type == 'richText'
                      "
                      clearable
                      v-model="formAttributeList[item.name]"
                      class="input"
                      size="small"
                    >
                    </el-input>
                    <el-select
                      style="width:400px;"
                      v-if="
                        item.input_type == 'singleSelect' ||
                          item.input_type == 'enumInput'
                      "
                      clearable
                      filterable
                      v-model="formAttributeList[item.name]"
                      placeholder="请选择"
                      class="input"
                      size="small"
                    >
                      <el-option
                        v-for="(value, index) in item.options"
                        :key="index"
                        :label="value.en_name ? value.en_name : value.name"
                        :value="value.id"
                      >
                      </el-option>
                    </el-select>
                    <el-select
                      style="width:400px;"
                      v-if="
                        item.input_type == 'multiSelect' ||
                          item.input_type == 'multiEnumInput'
                      "
                      clearable
                      filterable
                      multiple
                      v-model="formAttributeList[item.name]"
                      placeholder="请选择"
                      class="input"
                      size="small"
                    >
                      <el-option
                        v-for="(value, index) in item.options"
                        :key="index"
                        :label="value.en_name ? value.en_name : value.name"
                        :value="value.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="basic">
            <div v-if="platNo != '09'" class="form-title">
              选填项
            </div>
            <div class="form-content">
              <el-form-item
                v-if="item.showAttr"
                v-for="(item, number) of dataOptional"
                :label="item.attrName + '：'"
                :key="number"
                :prop="item.attrName"
              >
                <div class="form-label" slot="label">
                  <div
                    :title="item.attrName"
                    style="width: 176px"
                    class="text-ellipsis"
                  >
                    {{ item.attrName }}：
                  </div>
                </div>
                <div v-if="item.attrName == 'Category' && platNo == '05'">
                  <el-select
                    clearable
                    filterable
                    v-model="formOptional[item.attrId]"
                    placeholder="请选择"
                    class="input"
                    size="small"
                  >
                    <el-option
                      v-for="(value, index) in dictData['shopeeCategory']"
                      :key="index"
                      :label="value.label"
                      :value="value.value"
                    >
                    </el-option>
                  </el-select>
                  <div
                    :title="item.attrDesc"
                    style="float:left;"
                    class="text-ellipsis field-name"
                  >
                    {{ item.attrDesc }}
                  </div>
                </div>

                <div v-if="item.attrName == 'Ventures' && platNo == '03'">
                  <el-select
                    clearable
                    filterable
                    multiple
                    v-model="formOptional[item.attrId]"
                    placeholder="请选择"
                    class="input"
                    size="small"
                  >
                    <el-option
                      v-for="(value, index) in dictData['lazada_Ventures']"
                      :key="index"
                      :label="value.label"
                      :value="value.value"
                    >
                    </el-option>
                  </el-select>
                  <div
                    :title="item.attrDesc"
                    style="float:left;"
                    class="text-ellipsis field-name"
                  >
                    {{ item.attrDesc }}
                  </div>
                </div>

                <div v-else-if="item.attrName == 'Category' && platNo == '10'">
                  <TreeSelect
                    :props="treeSelectProps"
                    :options="categoryList"
                    v-model="formOptional[item.attrId]"
                    ref="childSelTree"
                    style="width: 100%"
                  ></TreeSelect>
                  <div
                    :title="item.attrDesc"
                    style="float:left;"
                    class="text-ellipsis field-name"
                  >
                    {{ item.attrDesc }}
                  </div>
                </div>

                <div v-else-if="item.attrName == 'Brand Id' && platNo == '10'">
                  <el-select
                    clearable
                    filterable
                    v-model="formOptional[item.attrId]"
                    placeholder="请选择"
                    class="input"
                    size="small"
                  >
                    <el-option
                      v-for="(value, index) in brandList"
                      :key="index"
                      :label="value.name"
                      :value="value.id"
                    >
                    </el-option>
                  </el-select>
                  <div
                    :title="item.attrDesc"
                    style="float:left;"
                    class="text-ellipsis field-name"
                  >
                    {{ item.attrDesc }}
                  </div>
                </div>

                <div v-else-if="item.attrName == 'Warehouse Id'">
                  <el-select
                    clearable
                    filterable
                    v-model="formOptional[item.attrId]"
                    placeholder="请选择"
                    class="input"
                    size="small"
                  >
                    <el-option
                      v-for="(value, index) in warehouses"
                      :key="index"
                      :label="value.warehouse_name"
                      :value="value.warehouse_id"
                    >
                    </el-option>
                  </el-select>
                  <div
                    :title="item.attrDesc"
                    style="float:left;"
                    class="text-ellipsis field-name"
                  >
                    {{ item.attrDesc }}
                  </div>
                </div>

                <div v-else-if="item.attrName == 'Neckline'">
                  <el-select
                    clearable
                    filterable
                    v-model="formOptional[item.attrId]"
                    placeholder="请选择"
                    class="input"
                    size="small"
                  >
                    <el-option
                      v-for="(value, index) in necklines"
                      :key="index"
                      :label="value.name"
                      :value="value.id"
                    >
                    </el-option>
                  </el-select>
                  <div
                    :title="item.attrDesc"
                    style="float:left;"
                    class="text-ellipsis field-name"
                  >
                    {{ item.attrDesc }}
                  </div>
                </div>
                <div v-else-if="item.attrName == 'Pattern'">
                  <el-select
                    clearable
                    filterable
                    v-model="formOptional[item.attrId]"
                    placeholder="请选择"
                    class="input"
                    size="small"
                  >
                    <el-option
                      v-for="(value, index) in patterns"
                      :key="index"
                      :label="value.name"
                      :value="value.id"
                    >
                    </el-option>
                  </el-select>
                  <div
                    :title="item.attrDesc"
                    style="float:left;"
                    class="text-ellipsis field-name"
                  >
                    {{ item.attrDesc }}
                  </div>
                </div>
                <div v-else-if="item.attrName == 'Clothing Material'">
                  <el-select
                    clearable
                    filterable
                    v-model="formOptional[item.attrId]"
                    placeholder="请选择"
                    class="input"
                    size="small"
                  >
                    <el-option
                      v-for="(value, index) in clothingMaterials"
                      :key="index"
                      :label="value.name"
                      :value="value.id"
                    >
                    </el-option>
                  </el-select>
                  <div
                    :title="item.attrDesc"
                    style="float:left;"
                    class="text-ellipsis field-name"
                  >
                    {{ item.attrDesc }}
                  </div>
                </div>
                <div v-else-if="item.attrName == 'Sleeves'">
                  <el-select
                    clearable
                    filterable
                    v-model="formOptional[item.attrId]"
                    placeholder="请选择"
                    class="input"
                    size="small"
                  >
                    <el-option
                      v-for="(value, index) in sleevess"
                      :key="index"
                      :label="value.name"
                      :value="value.id"
                    >
                    </el-option>
                  </el-select>
                  <div
                    :title="item.attrDesc"
                    style="float:left;"
                    class="text-ellipsis field-name"
                  >
                    {{ item.attrDesc }}
                  </div>
                </div>
                <div v-else-if="item.attrName == 'Season'">
                  <el-select
                    clearable
                    filterable
                    v-model="formOptional[item.attrId]"
                    placeholder="请选择"
                    class="input"
                    size="small"
                  >
                    <el-option
                      v-for="(value, index) in seasons"
                      :key="index"
                      :label="value.name"
                      :value="value.id"
                    >
                    </el-option>
                  </el-select>
                  <div
                    :title="item.attrDesc"
                    style="float:left;"
                    class="text-ellipsis field-name"
                  >
                    {{ item.attrDesc }}
                  </div>
                </div>

                <div v-else-if="item.attrName == 'Clothing Style'">
                  <el-select
                    clearable
                    filterable
                    v-model="formOptional[item.attrId]"
                    placeholder="请选择"
                    class="input"
                    size="small"
                  >
                    <el-option
                      v-for="(value, index) in clothingStyles"
                      :key="index"
                      :label="value.name"
                      :value="value.id"
                    >
                    </el-option>
                  </el-select>
                  <div
                    :title="item.attrDesc"
                    style="float:left;"
                    class="text-ellipsis field-name"
                  >
                    {{ item.attrDesc }}
                  </div>
                </div>

                <div
                  v-else-if="
                    item.attrName == 'Long Description (Lorikeet)' &&
                      platNo == '03'
                  "
                >
                  <CKEditor4
                    class="editor"
                    v-model="formOptional[item.attrId]"
                    @getCkEditorInstance="getEditor"
                    :config="editorConfig"
                    @open="openUploadDialog"
                  ></CKEditor4>
                  <div
                    :title="item.attrDesc"
                    style="    bottom: -23px;top: inherit;"
                    class="text-ellipsis field-name"
                  >
                    {{ item.attrDesc }}
                  </div>
                  <div
                    class="add-image-button-editor"
                    style=" top: -8px;    left: 826px; width: 200px;position: absolute;color: #4934b2;font-size:14px;"
                  >
                    <p>插入图片</p>
                    <div class="variable-select-box">
                      <ul class="variable-pick-ul">
                        <li
                          @click="handleAddSampleDesc(item, record, '2')"
                          v-for="record in imageSamplesDesc"
                          :key="record"
                        >
                          效果图{{ record }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div v-else-if="item.dataType == '02'">
                  <el-select
                    clearable
                    filterable
                    v-model="formOptional[item.attrId]"
                    placeholder="请选择"
                    class="input"
                    size="small"
                  >
                    <el-option
                      v-for="(value, index) in item.attrOptions"
                      :key="index"
                      :label="value.valName"
                      :value="value.valId"
                    >
                    </el-option>
                  </el-select>
                  <div
                    :title="item.attrDesc"
                    style="float:left;"
                    class="text-ellipsis field-name"
                  >
                    {{ item.attrDesc }}
                  </div>
                </div>
                <div v-else-if="item.dataType == '01'">
                  <el-input
                    style="float:left;width: 499px !important"
                    :readonly="
                      item.attrName == 'Color' ||
                      item.attrName == 'Size' ||
                      item.attrName == 'Option for Variation 1' ||
                      item.attrName == 'Option for Variation 2' ||
                      item.attrName == 'SKU Value 1' ||
                      item.attrName == 'SKU Value 2'
                        ? true
                        : false
                    "
                    :id="`input_${item.attrId}`"
                    :ref="`input_${item.attrId}`"
                    placeholder="请输入内容"
                    v-model="formOptional[item.attrId]"
                    show-word-limit
                    size="small"
                  ></el-input>

                  <div
                    v-if="
                      item.attrName != 'Color' &&
                        item.attrName != 'Size' &&
                        item.attrName != 'Option for Variation 1' &&
                        item.attrName != 'Option for Variation 2' &&
                        item.attrName != 'SKU Value 1' &&
                        item.attrName != 'SKU Value 2' &&
                        item.var
                    "
                    style="float:left;margin: 0 0 0 20px;position:relative;"
                    class="variable-insert"
                  >
                    <div class="insert-link">
                      插入变量
                      <div class="variable-select-menu">
                        <ul>
                          <li
                            class="variable-select-box-text"
                            :key="number"
                            v-for="(record, number) in varList"
                            @click="
                              handleInsertVariable(
                                formOptional,
                                item.attrId,
                                record.var
                              )
                            "
                          >
                            {{ record.name }}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <i
                      @mouseenter="handleShowVarHelp"
                      @mouseout="showVarHelp = false"
                      class="el-icon-question"
                    ></i>
                  </div>
                  <div
                    v-if="platNo != '03' && platNo != '05' && platNo != '10'"
                    style="float:left;margin: 0 0 0 20px;cursor:pointer;"
                  >
                    <el-button
                      size="small"
                      type="text"
                      @click="handleDelete(number)"
                      >删除
                    </el-button>
                  </div>
                  <div
                    :title="item.attrDesc"
                    style="float:left;"
                    class="text-ellipsis field-name"
                  >
                    {{ item.attrDesc }}
                  </div>
                </div>

                <ul
                  v-else-if="item.dataType == '08'"
                  class="extra-image-ul letter w70 detail-image-ul amazon sort-img active"
                >
                  <draggable
                    :list="item.imageGroup"
                    style="overflow: hidden; display: inline-block"
                    filter=".forbid"
                    @start="drag = true"
                    @end="drag = false"
                    :move="onMove"
                  >
                    <li
                      v-for="(record, index) in item.imageGroup"
                      :key="index"
                      class="sort-img-item"
                      :class="index === 0 ? 'forbid' : ''"
                    >
                      <div
                        @click="handleDeleteImage(item)"
                        v-if="
                          record.isMain &&
                            item.attrName != 'Item image 1' &&
                            item.attrName != 'Item image 1' &&
                            item.attrName != 'Item image 2' &&
                            item.attrName != 'Item image 3' &&
                            item.attrName != 'Item image 4' &&
                            item.attrName != 'Item image 5' &&
                            item.attrName != 'Item image 6' &&
                            item.attrName != 'Item image 7' &&
                            item.attrName != 'Item image 8' &&
                            item.attrName != 'Product Images1' &&
                            item.attrName != 'Product Images2' &&
                            item.attrName != 'Product Images3' &&
                            item.attrName != 'Product Images4' &&
                            item.attrName != 'Product Images5' &&
                            item.attrName != 'Product Images6' &&
                            item.attrName != 'Product Images7' &&
                            item.attrName != 'Product Images8'
                        "
                        class="item-badge"
                      >
                        删除
                      </div>
                      <p v-if="record.imageUrl.indexOf('http') === -1">
                        效果图{{ record.imageUrl }}
                      </p>
                      <img v-else :src="record.imageUrl" />
                      <span class="first-pro-icon icon-corner-mark"></span>
                    </li>
                  </draggable>
                  <li
                    class="forbid"
                    :class="{ 'add-image-button': true }"
                    v-if="item.imageGroup.length < 1"
                  >
                    <p><i class="el-icon-plus"></i></p>
                    <div class="variable-select-box">
                      <ul>
                        <li>
                          插入变量
                          <ul class="variable-pick-ul">
                            <li
                              @click="handleAddSample(item, record)"
                              v-for="record in imageSamples"
                              :key="record"
                            >
                              效果图{{ record }}
                            </li>
                          </ul>
                        </li>
                        <li @click="handleUploadImage(item)">本地图片</li>
                      </ul>
                    </div>
                  </li>
                  <div
                    v-if="platNo != '03' && platNo != '05' && platNo != '10'"
                    style="position: absolute;left: 139px;top: -14px;"
                  >
                    <el-button
                      size="small"
                      type="text"
                      @click="handleDelete(number)"
                      >删除
                    </el-button>
                  </div>
                </ul>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>

      <div class="sidebar__style">
        <div class="list__style">
          <div v-if="templateId">
            <a class="text-link" href="#selectTemplate">选择模板</a>
          </div>
          <div><a class="text-link" href="#basic">基础信息</a></div>
          <div><a class="text-link" href="#template">属性信息</a></div>
        </div>
        <div @click="handleBackTop" class="button__style goTop__style">
          返回<br />顶部
        </div>
        <div
          v-if="!isView"
          @click="handleSave"
          class="button__style submit__style"
        >
          保存<br />{{
            upload == "1" ? "待上传" : this.templateId ? "汇出" : "模板"
          }}
        </div>
      </div>
    </div>

    <CategoryDialog :shopId="shopId" v-model="categoryVisible"></CategoryDialog>
    <TermDialog
      :productName="productName"
      :templateInfo="templateInfo"
      @update="handleUpdateTerm"
      v-model="termVisible"
    ></TermDialog>

    <VarHelp ref="varHelp" v-show="showVarHelp"></VarHelp>
    <PriceConfigDialog
      :basicFormSkuList="basicForm.skuList"
      :designId="designIdRemit"
      v-model="priceConfigVisible"
      @update="handleSetPrice"
    ></PriceConfigDialog>
    <SizeColorDialog
      :colorList="basicForm.colorList"
      :sizeList="basicForm.sizeList"
      v-model="sizeColorVisible"
      @update="handleSetColorSize"
    ></SizeColorDialog>
    <LocalUpload :ckData="localUploadData"></LocalUpload>
    <OnlineUpload :ckData="onlineUploadData"></OnlineUpload>
  </div>
</template>

<script type="text/ecmascript-6">
import BasicControl from "../amazon/components/basicControl";
import { getProList } from "@/api/plat/platType";
import Breadcrumb from "@/components/common/Breadcrumb";
import { mapGetters } from "vuex";
import { getProductTypeList, getTemplateTypeList } from "@/api/plat/platType";
import { addTemplate, getTemplateInfo, addRemit, addAmazonRemit, getVarListDesign, getVarListColl, getVarList, listDefault } from "@/api/template/universal";
import { getOSSToken } from "@/api/setting";
import { getConfigKey } from "@/api/system/config";
import VarHelp from '../amazon/components/varHelp.vue'
import PriceConfigDialog from '../amazon/components/PriceConfigDialog'
import SizeColorDialog from '../amazon/components/SizeColorDialog'
import CategoryDialog from '../amazon/components/CategoryDialog'
import TermDialog from './TermDialog'
import draggable from "vuedraggable"
import { listDesignColorsize, listAmazonColorsize, getRemitInfo } from "@/api/template/template";
import { getDomainList, } from "@/api/system/domain"
import { getWarehouse, getCategories, getBrand, getCategoryAttributeAllTiktok } from "@/api/order/tiktok"
import { getCategoryAttributeAllLazada } from "@/api/order/lazada"
import { getCategoryAttributeAllShopee } from "@/api/order/shopee"


import TreeSelect from "@/components/common/treeSelect"
import LocalUpload from "@/components/common/ckEditorUploadPage/localUpload"
import OnlineUpload from "@/components/common/ckEditorUploadPage/onlineUpload"
import CKEditor4 from "@/components/common/CKEditor"
import { getLazadaCategory, getCategoryAttribute,getBrandByPages } from "@/api/shop/shop"
import { getSkuList } from "@/api/template/template"

export default {
  name: "createTemplate",
  components: { BasicControl, Breadcrumb, VarHelp, PriceConfigDialog,CategoryDialog,TermDialog, SizeColorDialog ,draggable, TreeSelect, CKEditor4,  LocalUpload,
    OnlineUpload },
  props: {
    templateId : {
      type : String,
      default: ''
    },
    shopId : {
      type : String,
      default: ''
    },
    designId : {
      type : String,
      default: ''
    },
    remitData: {
      type: Object,
      default: {}
    },
    amazonSite : {
      type : String,
      default: ''
    },
    isMainland : {
      type : String,
      default: ''
    }
  },
  data() {
    return {
      basicForm: {
        templateName: "",
        picRemitMode: "01",
        productPicAddr: "",
        attrList: [],
        skuList: [],
        colorList: [],
        sizeList: [],
        picSizeH: '800',
        picSizeW: '800',
        saleForm: '01'
      },
      requireFields:[
        'catId',
        'Category',
        'Package Height (cm)',
        'Package Width (cm)',
        'Package Weight (kg)',
        'Size',
        'Color',
        'SellerSKU',
        'Stock',
        'Package Length (cm)',
        'Category',
        'Product Description',
        'Weight',
        'Length',
        'Width',
        'Height',
        'Price',
        'Product Name',
        'Brand',
        'Warehouse Id',
        'Warranty Type',
        'Warranty',
        'Brand Id',
        'Image per Variation',
        'Day to ship',
        'Retail price'
      ],
      designIdRemit: '',
      dataFields: [],
      warrantyList: [],
      warrantyTypeList: [],
      sizeConfig: 800,
      showPicSize: false,
      picSizeH: '',
      picSizeW: '',
      form: {
        attrId: '',
        attrName: '',
        attrRemit: '',
        attrValue: ''
      },
      rank:[],
      catOptions: [],
      formRequire: {},
      dataRequire: [],
      formOptional: {},
      dataOptional: [],
       pictureAddresses: [],
       priceConfigVisible: false,
       categoryVisible: false,
       sizeColorVisible: false,
       termVisible: false,
       pId: '',
       isSave: false,
       showVarHelp: false,
       attrList: [],
       dialogVisible: false,
       dialogTitle: '添加属性',
       editIndex: -1,
       imageSamples: ["1","2","3","4","5","6","7","8","9","10","11","12"],
       imageSamplesDesc: ["1","2","3","4","5"],
       imageGroup: [],
       varList: [],
       formType: 'normal',
       aliyunOssToken: {},
       platNo: '',
       upload: '0',
       platName: '',
       warehouses: [],
       categoryList: [],
       brandList: [],
       brandListLazada: [],
       clothingMaterials: [],
       necklines: [],
       patterns: [],
       sleevess: [],
       seasons: [],
       clothingStyles: [],
       formInline: {
          user: '',
          region: ''
       },
       formAttributeList:{},
       attributeList: [],
       currrentRow: {},
       remitId: '',
        treeSelectProps: {
        value: "id", // ID字段名
        label: "local_display_name", // 显示名称
        children: "child", // 子级字段名
      },
       catSelectProps: {
        value: "category_id", // ID字段名
        label: "name", // 显示名称
        children: "children", // 子级字段名
      },
       editorConfig: {
        allowedContent: true, //设置为true，以防止CKEditor 4删除不允许的元素
        extraPlugins: ["uploadImg"],
        height: "300px",
        toolbar: [
          ["Maximize"],
          ["Bold", "Italic", "Underline", "Strike"],
          ["TextColor", "BGColor"],
          [
            "JustifyLeft",
            "JustifyCenter",
            "JustifyRight",
            "JustifyBlock",
            "-",
            "NumberedList",
            "BulletedList",
            "-",
            "Outdent",
            "Indent",
            "-",
            "Subscript",
            "Superscript",
          ],
          ["HorizontalRule", "RemoveFormat"],
          ["Undo", "Redo"],
          "/",
          ["Styles", "Format", "Font", "FontSize"],
          ["Table"],
          ["uploadImg"],
        ],
        language: "zh-cn",
        wordcount: {
          showCharCount: true,
        },
      },
       editor: null,
      localUploadData: {
        visible: false,
        editor: null,
      },
      onlineUploadData: {
        visible: false,
        editor: null,
      },
      isLoad: false,
      mainPicColor: '',
      mainPicColorOptions: [],
      mainPicColorSort: '',
      templateInfo: '',
      templateInfoSort: '',
      productName: '',
    };
  },
 watch: {
    templateId: {
      handler(){
        let remitId = this.$route.query.remitId
        if(this.templateId && !remitId){
          this.loadData(this.templateId)
          this.getTemplate(this.templateId)
          this.getValues()
          return
        }

        if(this.templateId && remitId && this.isLoad){
          this.loadData(this.templateId)
          this.getTemplate(this.templateId)
          this.getValues()
        }
        this.isLoad = true
      },
      immediate: true
    },
    shopId: {
      handler(){
        if(this.shopId){
          this.getValues()
        }
      },
      immediate: true
    },
    isMainland: {
      handler(){
        if(this.isMainland == '01'){
          for(let i = 0;i< this.dataRequire.length;i++){
            if(this.dataRequire[i].attrName == 'Day to ship'){
              this.dataRequire[i].showAttr = true;
            }
            if(this.dataRequire[i].attrName == 'Retail price'){
              this.dataRequire[i].showAttr = true;
            }
          }
          for(let i = 0;i< this.dataOptional.length;i++){
            if(this.dataOptional[i].attrName == 'Ventures'){
              this.dataOptional[i].showAttr = true;
            }
          }
        }else {
          for(let i = 0;i< this.dataRequire.length;i++){
            if(this.dataRequire[i].attrName == 'Day to ship'){
              this.dataRequire[i].showAttr = false;
            }
            if(this.dataRequire[i].attrName == 'Retail price'){
              this.dataRequire[i].showAttr = false;
            }
          }
          for(let i = 0;i< this.dataOptional.length;i++){
            if(this.dataOptional[i].attrName == 'Ventures'){
              this.dataOptional[i].showAttr = false;
            }
          }
        }
      },
      immediate: true
    },
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
    isYx(){
      let isYx = this.$route.query.isYx
      if(isYx){
        return true
      }else {
        return false
      }
    },
    isView(){
      return this.$route.query.isView === '1'
    },
  },
  methods: {
    getOssToken() {
      var _self = this
      getOSSToken()
        .then(function (res) {
          if (res.code == 200) {
            _self.aliyunOssToken = res.data
          } else {
            _self.$message.error(res.msg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      },
    getEditor(editor) {
        this.editor = this.localUploadData.editor = this.onlineUploadData.editor = editor
        let timer = window.setInterval(()=>{
          if(document.querySelector('.cke_button__image')){
            document.querySelector('.cke_button__image').style.display = 'none'
            clearInterval(timer)
          }
        }, 1000)
    },
    openUploadDialog(val) {
      if (val == "local") {
        this.localUploadData.visible = true
      } else if (val == "online") {
        this.onlineUploadData.visible = true
      }
    },
     getConfigKey(){
      getConfigKey("pic_url")
        .then(async (res) => {
         if (res.code == 200) {
            let array = []
            let result = await getDomainList({
              checkStatus: '02'
            })
            if(result.rows.length > 0){
              for(let record of result.rows){
                array.push('http://' + record.busiDomain)
              }
            }
            array.push(res.msg)
            this.pictureAddresses  = array
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    async listDefault(){
      this.dataRequire = []
      this.dataOptional = []
      let result =  await listDefault({platNo: this.platNo})
      this.processData(result.rows)
    },
    handleShowTermDialog(){
      if(this.platNo == '03'){
        this.productName = this.formRequire['30004']
      } else if(this.platNo == '05'){
        this.productName = this.formRequire['50002']
      } else if(this.platNo == '10'){
        this.productName = this.formRequire['50016']
      }
      this.termVisible = true;
    },
    async getRank(){
      this.rank = []
      let result =  await listDefault({platNo: this.platNo})
      for(let record of result.rows){
        this.rank.push(record.attrName)
      }
    },
    handleUpdateTerm(templateInfo){
      this.templateInfo = templateInfo
    },
    async processData(data){
      let dataRequire = []
      let dataOptional = []
      for(let i = 0;i< data.length;i++){
       data[i].showAttr = true
      }
      //先删掉mainPicColor
      for(let i = 0;i< data.length;i++){
        if(data[i].attrName == 'mainPicColor'){
          this.mainPicColor = data[i].attrValue
          this.mainPicColorSort = data[i].sort
          data.splice(i, 1)
          break
        }
      }
      //删掉Template Info
      let findTemplateInfo = false
       for(let i = 0;i< data.length;i++){
        if(data[i].attrName == 'Template Info'){
          this.templateInfo = data[i].attrValue
          this.templateInfoSort = data[i].sort
          data.splice(i, 1)
          findTemplateInfo = true
          break
        }
      }
      if(!findTemplateInfo){
        this.templateInfo = ''
      }

      //获取产品名称
      for(let i = 0;i< data.length;i++){
        if(data[i].attrName == 'Product Name'){
          this.productName = data[i].attrValue
          break
        }
      }

      for(let i = 0;i< data.length;i++){
        if(data[i].attrName == 'Image per Variation'){
          // indexImage = i;
          if(!data[i].attrDefaultValue){
            data[i].attrDefaultValue = '效果图1'
          }
        }
      }
      //把ventures放第一个
      if(this.platNo == '03'){
        // let indexVentures = 0;
        for(let i = 0;i< data.length;i++){
          if(data[i].attrName == 'Ventures'){
            // indexVentures = i;
            if(data[i].attrValue){
              data[i].attrValue = data[i].attrValue.split(',')
            }
            break;
          }
        }
        // let temp = data[indexVentures]
        // data.splice(indexVentures, 1)
        // data.splice(0 , 0 , temp)
      }

      //非跨境店的时候需要隐藏
      if(this.platNo == '05'){
        if(this.isMainland != '01'){
          for(let i = 0;i< data.length;i++){
            if(data[i].attrName == 'Day to ship'){
              data[i].showAttr = false;
              break;
            }
          }
        }else {
          for(let i = 0;i< data.length;i++){
            if(data[i].attrName == 'Day to ship'){
              data[i].showAttr = true;
              break;
            }
          }
        }
      }

      if(this.platNo == '03'){
        if(this.isMainland != '01'){
          for(let i = 0;i< data.length;i++){
            if(data[i].attrName == 'Retail price'){
              data[i].showAttr = false;
            }
            if(data[i].attrName == 'Ventures'){
              data[i].showAttr = false;
            }
          }
        }else {
          for(let i = 0;i< data.length;i++){
            if(data[i].attrName == 'Retail price'){
              data[i].showAttr = true;
            }
            if(data[i].attrName == 'Ventures'){
              data[i].showAttr = true;
            }
          }
        }
      }


      //对调Size Chart顺序
      // if(this.platNo == '10'){
      //   let indexSA1 = 0;
      //   let indexSC = 0;
      //   for(let i = 0;i< data.length;i++){
      //     if(data[i].attrName == 'Sales Attributes 1'){
      //       indexSA1 = i;
      //     }
      //     if(data[i].attrName == 'Size Chart'){
      //       indexSC = i;
      //     }
      //   }
      //   let temp = data[indexSC]
      //   data.splice(indexSC, 1)
      //   data.splice(indexSA1, 0 , temp)
      // }



      this.dataFields = JSON.parse(JSON.stringify(data))

      for(let record of data){
        record.attrRemit =  record.attrRemit ?  record.attrRemit: record.attrDefaultRemit
        record.attrValue = record.attrValue ?  record.attrValue: record.attrDefaultValue
        if(record.dataType == '08'){
          if(record.attrValue){
            record.attrValue = record.attrValue.replace('效果图','')
            record.imageGroup = [{
              imageUrl: record.attrValue,
              isMain: true
            }]
          } else {
            record.imageGroup = []
          }
        }
        if(record.attrName == 'catId' && this.platNo == '03' && this.shopId){
          if(this.catOptions.length == 0){
            let result = await getLazadaCategory(this.shopId)
            this.catOptions = result.data
          }
          if(this.brandListLazada.length == 0 && record.attrValue){
            let result =  await getBrandByPages({shopId: this.shopId, categoryId: record.attrValue})
            this.brandListLazada = result.data
          }
        }

       if(record.attrName == 'Category' && this.platNo == '10' && this.shopId && record.attrValue){
          record.attrValue = this.getPathById(record.attrValue, this.categoryList)
       }


       if(record.attrName == 'catId' && this.platNo == '03' && this.shopId && record.attrValue){
          record.attrValue = this.getPathByIdLazada(record.attrValue, this.catOptions)
        }

        if(!this.shopId && record.attrName == 'Warehouse Id'){
          continue
        }
        if(!this.shopId && record.attrName == 'Category' && this.platNo == '10'){
          continue
        }
        if(!this.shopId && record.attrName == 'catId' && this.platNo == '03'){
          continue
        }

         if(!this.shopId && record.attrName == 'Warranty' && this.platNo == '03'){
          continue
        }

         if(!this.shopId && record.attrName == 'Warranty Type' && this.platNo == '03'){
          continue
        }
         if(!this.shopId && record.attrName == 'Brand' && this.platNo == '03'){
          continue
        }

        if(record.attrName == 'Brand Id' && !record.attrValue){
          record.attrValue = ''
        }

        if(this.requireFields.includes(record.attrName)){
          this.formRequire[record.attrId] = record.attrValue
          dataRequire.push(record)
        } else{
          this.formOptional[record.attrId] = record.attrValue
          dataOptional.push(record)
        }
      }
      this.dataRequire = dataRequire
      this.dataOptional = dataOptional

      this.formRequire = JSON.parse(JSON.stringify(this.formRequire))
      this.formOptional = JSON.parse(JSON.stringify(this.formOptional))
      this.attrList = data
    },
    handleSavePicSize(){
      if(this.sizeConfig == 0){
        if(!this.picSizeW ){
          this.msgError('请输入宽度')
          return
        }
        if(!this.picSizeH){
          this.msgError('请输入高度')
          return
        }
        this.basicForm.picSizeW = this.picSizeW
        this.basicForm.picSizeH = this.picSizeH
      }else if(this.sizeConfig == 1600){
        this.basicForm.picSizeW = '1600'
         this.basicForm.picSizeH = '1600'
      }else if(this.sizeConfig == 800){
        this.basicForm.picSizeW = '800'
         this.basicForm.picSizeH = '800'
      }
      else if(this.sizeConfig == 1200){
        this.basicForm.picSizeW = '1200'
         this.basicForm.picSizeH = '1200'
      }
      else if(this.sizeConfig == 2000){
        this.basicForm.picSizeW = '2000'
        this.basicForm.picSizeH = '2000'
      }
      this.showPicSize = false
    },
     handleBackTop(){
      window.scroll(0,0)
    },
    handleUploadImage(item){
      this.currrentRow = item
      document.querySelector('#fileUpload').click()
    },
    async loadData(templateId){
      if(templateId){
        let result = await getTemplateInfo(templateId)
        if(!result.data.saleForm){
          result.data.saleForm = '01'
        }
        this.basicForm = result.data

        this.processData(result.data.attrList)
        this.initPicSizeConfig()
        let pId = this.$route.query.pId
        let designId = this.$route.query.designId
        if(designId){
            this.designId = designId
            this.templateId = templateId
            result = await listDesignColorsize({
              templateId: templateId,
              designId: designId,
            })
            this.basicForm.colorList = result.data.colorList
            this.basicForm.sizeList = result.data.sizeList

            //设置mainPicColorOptions
            result = await listDesignColorsize({
              templateId: templateId,
              designId: designId.split(',')[0],
            })
            this.mainPicColorOptions = result.data.colorList
            // this.mainPicColor = this.mainPicColorOptions[0].sysName
        }

        if(pId){
          result = await listAmazonColorsize({
            templateId: this.templateId,
            pId: pId,
          })
          this.basicForm.colorList = result.data.colorList
          this.basicForm.sizeList = result.data.sizeList
        }
        this.handleChangeShopeeCategory()
      }

    },
    handleDeleteTemplateInfo(){
      this.templateInfo = ''
    },
    handleSaveFile() {
        var _self = this
        var getSuffix = function (fileName) {
          var pos = fileName.lastIndexOf(".")
          var suffix = ""
          if (pos != -1) {
            suffix = fileName.substring(pos)
          }
          return suffix
        }

        var file = $("#fileUpload").val()
        if (file.length == 0) {
          alert("请选择文件")
        }

        var filename = new Date().getTime() + getSuffix(file)
        var formData = new FormData()

        //注意formData里append添加的键的大小写
        formData.append("key", _self.aliyunOssToken.dir + filename) //存储在oss的文件路径
        formData.append("OSSAccessKeyId", _self.aliyunOssToken.accessid) //accessKeyId
        formData.append("policy", _self.aliyunOssToken.policy) //policy
        formData.append("Signature", _self.aliyunOssToken.signature) //签名
        //如果是base64文件，那么直接把base64字符串转成blob对象进行上传就可以了

        formData.append("file", $("#fileUpload")[0].files[0])
        formData.append("success_action_status", 200) //成功后返回的操作码

        var url = _self.aliyunOssToken.host
        var fileUrl =
          _self.aliyunOssToken.host + "/" + _self.aliyunOssToken.dir + filename
        $.ajax({
          url: url,
          type: "POST",
          data: formData,
          // async: false,
          cache: false,
          contentType: false,
          processData: false,
          success:  function (data) {
            _self.currrentRow.imageGroup.push({
              imageUrl: fileUrl,
              isMain: _self.currrentRow.imageGroup.length === 0 ? true : false
            })
            _self.currrentRow.attrValue = fileUrl

            if(_self.formOptional.hasOwnProperty(_self.currrentRow.attrId)){
            _self.formOptional[_self.currrentRow.attrId] = fileUrl
            }
            if(_self.formRequire.hasOwnProperty(_self.currrentRow.attrId)){
             _self.formRequire[_self.currrentRow.attrId] = fileUrl
            }

            $("#fileUpload").val(null)

            _self.formRequire = JSON.parse(JSON.stringify(_self.formRequire))
            _self.formOptional = JSON.parse(JSON.stringify(_self.formOptional))
          },
          error: function (data) {
             $("#fileUpload").val(null)
          },
        })
    },
    handleSetColorSize(record){
      this.basicForm.colorList = record.colorList
      this.basicForm.sizeList = record.sizeList
    },
    async getVarList(){
      let pId = this.$route.query.pId
      let designId = this.$route.query.designId
      if (pId) {
        let result = await getVarListColl()
        this.varList = result.rows
      }  else if(designId) {
        let result = await getVarListDesign()
        this.varList = result.rows
      }else {
          let result = await getVarList()
        this.varList = result.rows
      }
    },
     handleInsertVariable(forms,attrId, value){
      this.insertAtCursor(forms,attrId, value)
    },
    async insertAtCursor(forms,attrId,value) {
      var myValue = value
      const myField = document.querySelector('#input_' + attrId)
      if (myField.selectionStart || myField.selectionStart === 0) {
        var startPos = myField.selectionStart
        var endPos = myField.selectionEnd
        forms[attrId] = myField.value.substring(0, startPos) + myValue + myField.value.substring(endPos, myField.value.length)
        await this.$nextTick() // 这句是重点, 圈起来,不加的话后面两步有问题
        myField.focus()
        myField.setSelectionRange(endPos + myValue.length, endPos + myValue.length)
      } else {
        forms[attrId] = (forms[attrId] ? forms[attrId] : '') + value
      }
    },
    async handleInsertColorSize(value){
      var myValue = value
      const myField = document.querySelector('#input_color')
      if (myField.selectionStart || myField.selectionStart === 0) {
        var startPos = myField.selectionStart
        var endPos = myField.selectionEnd
        this.basicForm.color_name = myField.value.substring(0, startPos) + myValue + myField.value.substring(endPos, myField.value.length)
        await this.$nextTick() // 这句是重点, 圈起来,不加的话后面两步有问题
        myField.focus()
        myField.setSelectionRange(endPos + myValue.length, endPos + myValue.length)
      } else {
        this.basicForm.color_name = (this.basicForm.color_name ? this.basicForm.color_name : '') + value
      }
    },
      handleShowVarHelp(event){
      this.$refs['varHelp'].$el.style.top = event.clientY + 'px'
      this.showVarHelp = true
    },
    async confirm(text){
      return new Promise((resolve, reject)=>{
        this.$confirm(text, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
          resolve(true)
        }).catch(() => {
          resolve(false)
        });
      })
    },
    handleSave(){
      this.$refs['basicForm'].validate(async (valid)=>{
        if(valid){


          let form = this._.clone(this.basicForm)
          let action = this.$route.query.action
          let designId = this.$route.query.designId
          let remitId = this.$route.query.remitId
          if(designId){
            designId = designId.split(',')
          }
          let skuNum = this.$route.query.skuNum
          let platNo = this.platNo
          form.platNo = platNo
          if(this.upload == '1'){
            form.remitMode = '02'
          }
          if(action == 'copy'){
            form.templateId = ''
          }

          //判断SKU数量是否合法
          if(platNo == '05' && designId &&  skuNum){
            let skus = []
            skuNum = skuNum.split(',')
            for(let i=0;i<designId.length;i++){
              skus.push({
                designId: designId[i],
                skuNum: skuNum[i],
                skuNumReal: 0,
              })
            }
            if(!this.basicForm.skuList){
              for(let record of skus){
                if(record.skuNum > 50){
                  this.msgError('汇出数据中单品有超过50个sku，官方限制上传，需在指定颜色、尺码汇出按钮设置筛选汇出颜色')
                  return
                }
              }
            }else {
              for(let record of this.basicForm.skuList){
                for(let sku of skus){
                  if(record.designId == sku.designId){
                    sku.skuNumReal++;
                    break
                  }
                }
              }
              for(let record of skus){
                if(record.skuNumReal > 50){
                  this.msgError('汇出数据中单品有超过50个sku，官方限制上传，需在指定颜色、尺码汇出按钮设置筛选汇出颜色')
                  return
                }
              }
            }
          }else if (platNo == '05' && remitId &&  skuNum){
            if(this.basicForm.skuList && this.basicForm.skuList.length > 50){
              this.msgError('汇出数据中单品有超过50个sku，官方限制上传，需在指定颜色、尺码汇出按钮设置筛选汇出颜色')
              return
            }else if(!this.basicForm.skuList && skuNum > 50){
              this.msgError('汇出数据中单品有超过50个sku，官方限制上传，需在指定颜色、尺码汇出按钮设置筛选汇出颜色')
              return
            }
          }

          var filter = /[\u4E00-\u9FA5\uF900-\uFA2D]{1,}/;
          //判断尺码和颜色是否含有中文
          if(form.colorList){
            for(let record of form.colorList){
              if (filter.test(record.customizeName) ||
              (filter.test(record.sysName) && filter.test(record.customizeName)) ||
              (filter.test(record.sysName) && !record.customizeName)) {
                let flag = await this.confirm("产品颜色不能含有中文，请点击“颜色、尺码名称自定义”修改")
                if(!flag){
                  return
                } else {
                  this.sizeColorVisible = true
                  return
                }
              }
            }
          }
          if(form.sizeList){
            for(let record of form.sizeList){
               if (filter.test(record.customizeName) ||
              (filter.test(record.sysName) && filter.test(record.customizeName)) ||
              (filter.test(record.sysName) && !record.customizeName)) {
                let flag = await this.confirm("产品尺码不能含有中文，请点击“颜色、尺码名称自定义”修改")
                if(!flag){
                  return
                } else {
                  this.sizeColorVisible = true
                  return
                }
              }
            }
          }



          form.attrList = this.dataFields



          if(this.formRequire['50001'] && this.platNo == '10'){
            let categoryId = this.formRequire['50001']
            if(typeof this.formRequire['50001'] == 'object'){
              categoryId = this.formRequire['50001'][this.formRequire['50001'].length - 1]
            }
            this.formRequire['50001'] = categoryId
          }

           if(this.formRequire['30002'] && this.platNo == '03'){
            let categoryId = this.formRequire['30002']
            if(typeof this.formRequire['30002'] == 'object'){
              categoryId = this.formRequire['30002'][this.formRequire['30002'].length - 1]
            }
            this.formRequire['30002'] = categoryId
          }

          for(let record of form.attrList){
            if(this.formRequire.hasOwnProperty(record.attrId)){
              record.attrValue = this.formRequire[record.attrId]
            }

            if(this.formOptional.hasOwnProperty(record.attrId)){
              record.attrValue = this.formOptional[record.attrId]
            }
          }

          if(platNo == '03'){
            for(let record of form.attrList){
              //   if(record.attrName == 'Product Images1' && !record.attrValue){
              //   this.msgError('Product Images1字段需要必填')
              //   return
              // }
                if(record.attrName == 'Product Name' && !record.attrValue && !this.templateInfo){
                this.msgError('Product Name字段需要必填')
                return
              }

              if(record.attrName == 'catId' && !record.attrValue && this.shopId){
                this.msgError('catId字段需要必填')
                return
              }


              //  if(record.attrName == 'Brand' && !record.attrValue){
              //   this.msgError('Brand字段需要必填')
              //   return
              // }


                if(record.attrName == 'Package Height (cm)' && !record.attrValue){
                this.msgError('Package Height (cm)字段需要必填')
                return
              }else if(record.attrName == 'Package Height (cm)' && record.attrValue){
                var regex = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/
                if(!regex.test(record.attrValue)){
                  this.msgError('Package Height (cm)字段必须是正数，不能字符')
                  return
                }
              }
                if(record.attrName == 'Package Width (cm)' && !record.attrValue){
                this.msgError('Package Width (cm)字段需要必填')
                return
              }else if(record.attrName == 'Package Width (cm)' && record.attrValue){
                var regex = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/
                if(!regex.test(record.attrValue)){
                  this.msgError('Package Width (cm)字段必须是正数，不能字符')
                  return
                }
              }
                if(record.attrName == 'Package Weight (kg)' && !record.attrValue){
                this.msgError('Package Weight (kg)字段需要必填')
                return
              }else if(record.attrName == 'Package Weight (kg)' && record.attrValue){
                var regex = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/
                if(!regex.test(record.attrValue)){
                  this.msgError('Package Weight (kg)字段必须是正数，不能字符')
                  return
                }
              }
                if(record.attrName == 'Size' && !record.attrValue){
                this.msgError('Size字段需要必填')
                return
              }
                if(record.attrName == 'Color' && !record.attrValue){
                this.msgError('Color字段需要必填')
                return
              }
                if(record.attrName == 'SellerSKU' && !record.attrValue){
                this.msgError('SellerSKU字段需要必填')
                return
              }
              if(record.attrName == 'SellerSKU' && record.attrValue && record.attrValue.indexOf('{id}') == -1){
                this.msgError('SellerSKU字段必须包含{id}变量')
                return
              }


              // if(record.attrName == 'Warranty Type' && this.shopId && !record.attrValue){
              //   this.msgError('Warranty Type字段需要必填')
              //   return
              // }

              // if(record.attrName == 'Warranty' && this.shopId && !record.attrValue){
              //   this.msgError('Warranty字段需要必填')
              //   return
              // }

              if(record.attrName == 'Stock' && !record.attrValue){
                this.msgError('Stock字段需要必填')
                return
              }else if(record.attrName == 'Stock' && record.attrValue){
                var regex = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/
                if(!regex.test(record.attrValue)){
                  this.msgError('Stock字段必须是正数，不能字符')
                  return
                }
              }
                if(record.attrName == 'Package Length (cm)' && !record.attrValue){
                this.msgError('Package Length (cm)字段需要必填')
                return
              }else if(record.attrName == 'Package Length (cm)' && record.attrValue){
                var regex = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/
                if(!regex.test(record.attrValue)){
                  this.msgError('Package Length (cm)字段必须是正数，不能字符')
                  return
                }
              }
                if(record.attrName == 'Price' && !record.attrValue){
                this.msgError('Price字段需要必填')
                return
              }

              if(record.attrName == 'Long Description (Lorikeet)') {
                record.attrValue = this.editor.getData();
              }

              if(record.attrName == 'Ventures' && record.attrValue) {
                record.attrValue = record.attrValue.join(',');
              }

              // else if(record.attrName == 'Price' && record.attrValue){
              //   var regex = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/
              //   if(!regex.test(record.attrValue)){
              //     this.msgError('Price字段必须是正数，不能字符')
              //     return
              //   }
              // }

            }
          }
          if(platNo == '05'){
            for(let record of form.attrList){
              if(record.attrName == 'Category' && !record.attrValue){
                this.msgError('Category字段需要必填')
                return
              }
              if(record.attrName == 'Product Name' && !record.attrValue && !this.templateInfo){
                this.msgError('Product Name字段需要必填')
                return
              }
                if(record.attrName == 'Product Description' && !record.attrValue){
                this.msgError('Product Description字段需要必填')
                return
              }

              if(record.attrName == 'Price' && !record.attrValue){
                this.msgError('Price字段需要必填')
                return
              }
              if(record.attrName == 'Product Description') {
                record.attrValue = this.editor.getData();
              }
               if(record.attrName == 'Image per Variation' && !record.attrValue){
                this.msgError('Image per Variation字段需要必填')
                return
              }

                if(record.attrName == 'Stock' && !record.attrValue){
                this.msgError('Stock字段需要必填')
                return
              }else if(record.attrName == 'Stock' && record.attrValue){
                var regex = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/
                if(!regex.test(record.attrValue)){
                  this.msgError('Stock字段必须是正数，不能是字符')
                  return
                }
              }

                if(record.attrName == 'Weight' && !record.attrValue){
                this.msgError('Weight字段需要必填')
                return
              }else if(record.attrName == 'Weight' && record.attrValue){
                var regex = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/
                if(!regex.test(record.attrValue)){
                  this.msgError('Weight字段必须是正数，不能字符')
                  return
                }
              }

                if(record.attrName == 'Length' && !record.attrValue){
                this.msgError('Length字段需要必填')
                return
              }else if(record.attrName == 'Length' && record.attrValue){
                var regex = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/
                if(!regex.test(record.attrValue)){
                  this.msgError('Length字段必须是正数，不能字符')
                  return
                }
              }

                if(record.attrName == 'Width' && !record.attrValue){
                this.msgError('Width字段需要必填')
                return
              }else if(record.attrName == 'Width' && record.attrValue){
                var regex = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/
                if(!regex.test(record.attrValue)){
                  this.msgError('Width字段必须是正数，不能字符')
                  return
                }
              }

                  if(record.attrName == 'Height' && !record.attrValue){
                this.msgError('Height字段需要必填')
                return
              }else if(record.attrName == 'Height' && record.attrValue){
                var regex = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/
                if(!regex.test(record.attrValue)){
                  this.msgError('Height字段必须是正数，不能字符')
                  return
                }
              }

              if(record.attrName == 'SKU' && record.attrValue && record.attrValue.indexOf('{id}') == -1){
                this.msgError('SKU字段必须包含{id}变量')
                return
              }

              if(record.attrName == 'Day to ship' && !record.attrValue  && this.isMainland == '01'){
                this.msgError('Day to ship字段需要必填')
                return
              }
            }
          }

          if(platNo == '10'){
            for(let record of form.attrList){

              if(record.attrName == 'Category' && !record.attrValue && this.shopId){
                this.msgError('Category字段需要必填')
                return
              }

              if(record.attrName == 'Product Name' && !record.attrValue && !this.templateInfo){
                this.msgError('Product Name字段需要必填')
                return
              }

              if(record.attrName == 'Product Description') {
                record.attrValue = this.editor.getData();
              }

              if(record.attrName == 'Product Description' && !record.attrValue){
                this.msgError('Product Description字段需要必填')
                return
              }
              if(record.attrName == 'Image per Variation' && !record.attrValue){
                this.msgError('Image per Variation字段需要必填')
                return
              }

              if(record.attrName == 'Price' && !record.attrValue){
                this.msgError('Price字段需要必填')
                return
              }
              if(record.attrName == 'Price' && record.attrValue){
                if(record.attrValue <30 && this.amazonSite== 'TH'){
                  this.msgError('泰国用户售卖价格Price至少30泰铢以上')
                  return
                }
                if(record.attrValue < 100 && this.amazonSite== 'ID'){
                  this.msgError('印尼用户售卖价格Price至少100印尼盾以上')
                  return
                }
              }


              if(record.attrName == 'Stock' && !record.attrValue){
                this.msgError('Stock字段需要必填')
                return
              }


              if(record.attrName == 'Width' && !record.attrValue){
                this.msgError('Width字段需要必填')
                return
              }


              if(record.attrName == 'Length' && !record.attrValue){
                this.msgError('Length字段需要必填')
                return
              }


              if(record.attrName == 'Height' && !record.attrValue){
                this.msgError('Height字段需要必填')
                return
              }

              if(record.attrName == 'Weight' && !record.attrValue){
                this.msgError('Weight字段需要必填')
                return
              }

                if(record.attrName == 'Warehouse Id' && !record.attrValue && this.shopId){
                this.msgError('Warehouse Id字段需要必填')
                return
              }

                if(record.attrName == 'Seller Sku' && record.attrValue && record.attrValue.indexOf('{id}') == -1){
                this.msgError('Seller Sku字段必须包含{id}变量')
                return
              }
            }
          }
          if(this.isSave){
            return
          }
          this.isSave = true



          //重新组装attrList
          let attrList = []
          if(this.platNo == '03' || this.platNo == '05'  || this.platNo == '10'){
            for(let record of this.rank){
              for(let item of form.attrList){
                if(item.attrName == record){
                  attrList.push(item)
                  break
                }
              }
            }
            form.attrList = attrList
          }

          try {
            let mainPicColor =
            {"createBy":null,"createTime":null,"updateBy":null,"updateTime":null,"remark":null,"beginTime":null,"endTime":null,"attrId":"50001","attrName":"mainPicColor","attrDefaultRemit":"mainPicColor","attrDefaultValue":null,"platNo":this.platNo,"attrDesc":null,"dataType":"01","attrOptions":[],"var":false}
            if(this.platNo == '03'){
              mainPicColor.attrId = '30066'
            } else if(this.platNo == '05'){
              mainPicColor.attrId = '50030'
            } else if(this.platNo == '10'){
              mainPicColor.attrId = '50033'
            }
            mainPicColor.attrValue = this.mainPicColor
            mainPicColor.sort = mainPicColor.attrId

            let templateInfo ={
              "createBy": null,
              "createTime": null,
              "updateBy": null,
              "updateTime": null,
              "remark": null,
              "beginTime": null,
              "endTime": null,
              "attrId": "50031",
              "attrName": "Template Info",
              "attrDefaultRemit": "Template Info",
              "attrDefaultValue": null,
              "platNo": this.platNo,
              "attrDesc": "词组模板信息",
              "dataType": "01",
              "attrOptions": [],
              "var": false,
              "sort": this.templateInfoSort
            }
            if(this.platNo == '03'){
              templateInfo.attrId = '30067'
            } else if(this.platNo == '05'){
              templateInfo.attrId = '50031'
            } else if(this.platNo == '10'){
              templateInfo.attrId = '50034'
            }
            templateInfo.sort =  templateInfo.attrId
            templateInfo.attrValue = this.templateInfo



            //开始提交目录
            form.attributeList = []
            if(this.attributeList.length > 0){
              for(let record of this.attributeList){
                let valueList = []
                if(typeof(this.formAttributeList[record.name]) == 'object'){
                   for(let item of this.formAttributeList[record.name]){
                    //开始获取name
                    let valueName = item
                    if(record.options && record.options.length > 0){
                      for(let value of record.options){
                        if(value.id == item){
                          valueName = value.en_name ? value.en_name : value.name
                          break
                        }
                      }
                    }

                    valueList.push({
                      valueId: item,
                      valueName: valueName,
                      valueUnit: ''
                    })
                  }
                } else {
                  let valueName = this.formAttributeList[record.name]
                  if(record.options && record.options.length > 0){
                    for(let value of record.options){
                      if(value.id == this.formAttributeList[record.name]){
                        valueName = value.en_name ? value.en_name : value.name
                        break
                      }
                    }
                  }
                  valueList.push({
                    valueId: this.formAttributeList[record.name],
                    valueName: valueName
                  })
                }

                form.attributeList.push({
                  attrId: record.id,
                  attrName: record.name,
                  remitId: this.remitId ? this.remitId: '',
                  valueList: valueList
                })
              }
            }

            mainPicColor.remitId = this.remitId
            mainPicColor.templateId = this.templateId
            templateInfo.remitId = this.remitId
            templateInfo.templateId = this.templateId

            form.attrList.push(mainPicColor)
            form.attrList.push(templateInfo)

            // if(this.platNo == '05'){
            //   let dayToShip = {}
            //   let find = false;
            //   for(let i = 0;i< form.attrList.length;i++){
            //     if(form.attrList[i].attrName == 'Day to ship'){
            //       dayToShip = form.attrList[i]
            //       form.attrList.splice(i, 1)
            //       find = true
            //       break
            //     }
            //   }
            //   if(find){
            //     form.attrList.push(dayToShip)
            //   }
            // }

            // if(this.platNo == '03'){
            //   let retailPrice = {}
            //   let find = false;
            //   for(let i = 0;i< form.attrList.length;i++){
            //     if(form.attrList[i].attrName == 'Retail price'){
            //       retailPrice = form.attrList[i]
            //       form.attrList.splice(i, 1)
            //       find = true
            //       break
            //     }
            //   }
            //   if(find){
            //     form.attrList.push(retailPrice)
            //   }
            // }

            // if(this.platNo == '03'){
            //   let ventures = {}
            //   let find = false;
            //   for(let i = 0;i< form.attrList.length;i++){
            //     if(form.attrList[i].attrName == 'Ventures'){
            //       ventures = form.attrList[i]
            //       form.attrList.splice(i, 1)
            //       find = true
            //       break
            //     }
            //   }
            //   if(find){
            //     form.attrList.push(ventures)
            //   }
            // }





            if(this.remitId){
              form.shopId = this.shopId
              form.remitId = this.remitId
              form.designId = this.designId
              this.insertSizeChart(form.attrList)
              await addRemit(form)
            }
            else if(this.templateId){
              form.templateId = this.templateId
              form.shopId = this.shopId

              if(this.pId){
                form.pId = this.pId
                await addAmazonRemit(form)
                this.msgSuccess("汇出成功，请到汇出记录中下载");
              }
              let designIds = []
              if(form.skuList && form.skuList.length > 0){
                for(let record of form.skuList){
                  if(!designIds.includes(record.designId)){
                    designIds.push(record.designId)
                  }
                }
              } else {
                designIds = this.designId.split(',')
              }


              if(this.designId){
                //开始配置颜色属性
                 this.insertSizeChart(form.attrList)

                 if(this.upload == '1'){
                  for(let i=0;i<designIds.length;i++){
                    form.designId = designIds[i]
                    let currentForm = this._.clone(form)
                    if(currentForm.skuList){
                      currentForm.skuList = currentForm.skuList.filter(record=>{
                        return record.designId == designIds[i]
                      })
                    }
                    await addRemit(currentForm)
                  }
                 } else{
                    form.designId = this.designId
                    await addRemit(form)
                 }
                this.msgSuccess("汇出成功，请到汇出记录中下载");
              }
            }
            else{
              this.insertSizeChart(form.attrList)
              await addTemplate(form);
              this.msgSuccess("保存成功");
            }
            this.$emit('submit')
          } catch (err) {
            console.log(err)
          } finally{
            this.isSave = false
          }
        }
      })
    },
    insertSizeChart(array){
      if(this.platNo == '10'){
        //sizeChart放最后
        let indexSC = 0;
        for(let i = 0;i< array.length;i++){
          if(array[i].attrName == 'Size Chart'){
            indexSC = i;
            break
          }
        }
        let temp = array[indexSC]
        array.splice(indexSC, 1)
        array.splice(array.length, 0 , temp)
      }
    },
    handleSetPrice(value){
      this.basicForm.skuList = value
      //获取最新的配置颜色
      let mainPicColorOptions = []
      let colors = []
      if(value && value.length > 0){
        let designId = value[0].designId
        for(let record of value){
          if(record.designId == designId){
            if(!colors.includes(record.color)){
              colors.push( record.color)
              mainPicColorOptions.push({
                sysName: record.color
              })
            }
          }
        }
        this.mainPicColorOptions = mainPicColorOptions
        // this.mainPicColor = mainPicColorOptions[0].sysName
      }
    },
     onMove(e){
        if(!e.relatedContext.element){
          return false
        }
        if(e.relatedContext.element.isMain){
          return false
        }
        return true
    },
    handleUp(index){
      let table = this._.clone(this.basicForm.attrList)
      if(index == 0){
        return
      }
      let object = table[index - 1]
      table[index - 1] = table[index]
      table[index] = object
      this.basicForm.attrList = table
    },
    async getValues(){
      let platNo  = this.$route.query.platNo
      if(platNo == '10'){
        if(this.shopId){
          let result = await getWarehouse({shopId: this.shopId})
          this.warehouses = result.data
          if(this.warehouses.length > 0){
            this.formRequire['50022'] = result.data[0].warehouse_id
          }
        }
      }
      if(platNo == '10'){
        if(this.shopId){
          let result = await getCategories({shopId: this.shopId})
          this.categoryList = result.data
        }
      }
    },
    async handleChangeCategory(){
      if(this.shopId && this.formRequire['50001'] && this.platNo == '10'){
        let categoryId = this.formRequire['50001']
        if(typeof this.formRequire['50001'] == 'object'){
          categoryId = this.formRequire['50001'][this.formRequire['50001'].length - 1]
        }
        let result = await getBrand({shopId: this.shopId, categoryId: categoryId})
        this.brandList = result.data
        this.brandList.unshift({id: '', name: '无品牌'})

        let response = await getCategoryAttributeAllTiktok({shopId: this.shopId, categoryId: categoryId})

        let formAttributeList = {}
        for(let record of response.data){
          record.options = record.values
          record.label = record.name
          record.is_mandatory = record.input_type.is_mandatory
          if(record.options && record.options.length > 0){
            for(let item of record.options){
              item.id = item.id.toString()
              item.name = item.name.toString()
            }
          }

          record.input_type = 'singleSelect'
          if(record.input_type.is_multiple_selected){
            record.input_type = 'multiSelect'
          }

          if(record.input_type == 'singleSelect')
          {
            if(record.options && record.options.length > 0){
              formAttributeList[record.name] = record.options[0].id
            }
          } else {
              if(record.options && record.options.length > 0){
              formAttributeList[record.name] = [record.options[0].id]
            }
          }
        }
        //加载数据
        if(this.basicForm && this.basicForm.attributeList && this.basicForm.attributeList.length > 0){
          for(let record of this.basicForm.attributeList){
            if(typeof(formAttributeList[record.attrName]) == 'string'){
              if(record.valueList && record.valueList.length > 0){
                formAttributeList[record.attrName] = record.valueList[0].valueId ? record.valueList[0].valueId : ''
              }else {
                formAttributeList[record.attrName] = ''
              }
            }else {
              formAttributeList[record.attrName] = []
              for(let item of record.valueList){
                formAttributeList[record.attrName].push(item.valueId ? item.valueId: '')
              }
            }
          }
        }

        this.formAttributeList = formAttributeList
        this.$nextTick(()=>{
          this.attributeList = response.data
        })

      }
    },
    async handleChangeLazadaCategory(){
      this.startLoading()
      if(this.shopId && this.formRequire['30002'] && this.platNo == '03'){
        let categoryId = this.formRequire['30002']
        if(typeof this.formRequire['30002'] == 'object'){
          categoryId = this.formRequire['30002'][this.formRequire['30002'].length - 1]
        }
        let result = await getCategoryAttribute({shopId: this.shopId, categoryId: categoryId})
        this.warrantyList = result.data.warranty
        this.warrantyTypeList = result.data.warranty_type

        if(result.data.m_top_neckline){result.data.m_top_neckline.map((record)=>{record.id = record.id.toString()})}
        if(result.data.fa_pattern){result.data.fa_pattern.map((record)=>{record.id = record.id.toString()})}
        if(result.data.clothing_material){result.data.clothing_material.map((record)=>{record.id = record.id.toString()})}
        if(result.data.m_sleeve_length){result.data.m_sleeve_length.map((record)=>{record.id = record.id.toString()})}
        if(result.data.fa_season){result.data.fa_season.map((record)=>{record.id = record.id.toString()})}
        if(result.data.fa_general_styles){result.data.fa_general_styles.map((record)=>{record.id = record.id.toString()})}

        this.necklines = result.data.m_top_neckline
        this.patterns = result.data.fa_pattern
        this.clothingMaterials = result.data.clothing_material
        this.sleevess = result.data.m_sleeve_length
        this.seasons = result.data.fa_season
        this.clothingStyles = result.data.fa_general_styles

        let response =  await getBrandByPages({shopId: this.shopId, categoryId: categoryId})
        this.brandListLazada = response.data

        response = await getCategoryAttributeAllLazada({shopId: this.shopId, categoryId: categoryId})

        let formAttributeList = {}
        for(let record of response.data){
           if(record.options && record.options.length > 0){
            for(let item of record.options){
              item.id = item.id.toString()
              item.name = item.name.toString()
            }
           }
           if(record.input_type == 'numeric' && record.options && record.options.length > 0){
            record.input_type = 'singleSelect'
           }


          if(record.input_type == 'text'
          || record.input_type == 'richText'
          || record.input_type == 'singleSelect'
          || record.input_type == 'numeric'
          || record.input_type == 'enumInput')
          {
            if(record.options && record.options.length > 0){
              formAttributeList[record.name] = record.options[0].id
            }
          } else {
             if(record.options && record.options.length > 0){
              formAttributeList[record.name] = [record.options[0].id]
              }
          }
        }
        //加载数据
        if(this.basicForm && this.basicForm.attributeList && this.basicForm.attributeList.length > 0){
          for(let record of this.basicForm.attributeList){
            if(typeof(formAttributeList[record.attrName]) == 'string'){
              if(record.valueList && record.valueList.length > 0){
                formAttributeList[record.attrName] = record.valueList[0].valueId ? record.valueList[0].valueId : ''
              }else {
                formAttributeList[record.attrName] = ''
              }
            }else {
              formAttributeList[record.attrName] = []
              for(let item of record.valueList){
                formAttributeList[record.attrName].push(item.valueId ? item.valueId: '')
              }
            }
          }
        }

        this.formAttributeList = formAttributeList
        this.$nextTick(()=>{
          this.attributeList = response.data
        })
      }
      this.endLoading()
    },
    async handleChangeShopeeCategory(){
      this.startLoading()
      if(this.shopId && this.formRequire['50001'] && this.platNo == '05'){
        let categoryId = this.formRequire['50001']
        let response = await getCategoryAttributeAllShopee({shopId: this.shopId, categoryId: categoryId})

        let formAttributeList = {}
        for(let record of response.data.attribute_list){
          if(record.input_type == 'MULTIPLE_SELECT_COMBO_BOX'
            || record.input_type == 'COMBO_BOX'
            || record.input_type == 'DROP_DOWN'
            ){
            for(let item of record.attribute_value_list){
              item.id = item.value_id.toString()
              item.name = item.original_value_name.toString()
            }
            record.options = record.attribute_value_list
          }
          record.id = record.attribute_id
          record.label = record.display_attribute_name
          record.name = record.original_attribute_name.replace(/\s/g, '')

          if(record.input_type == 'MULTIPLE_SELECT_COMBO_BOX'){
            record.input_type = 'multiSelect'
          }
          if(record.input_type == 'COMBO_BOX'){
            record.input_type = 'singleSelect'
          }
          if(record.input_type == 'DROP_DOWN'){
            record.input_type = 'singleSelect'
          }
          if(record.input_type == 'TEXT_FILED'){
            record.input_type = 'text'
          }
          if(record.input_type == 'text'
          || record.input_type == 'richText'
          || record.input_type == 'singleSelect'
          || record.input_type == 'numeric'
          || record.input_type == 'enumInput')
          {
            if(record.options && record.options.length > 0){
              formAttributeList[record.name] = record.options[0].id
            }
          } else {
             if(record.options && record.options.length > 0){
              formAttributeList[record.name] = [record.options[0].id]
              }
          }
        }

        //加载数据
        if(this.basicForm && this.basicForm.attributeList && this.basicForm.attributeList.length > 0){
          for(let record of this.basicForm.attributeList){
            if(record.valueList && record.valueList.length > 0){
              if(typeof(formAttributeList[record.attrName]) == 'string'){
                formAttributeList[record.attrName] = record.valueList[0].valueId ? record.valueList[0].valueId : ''
              }else {
                formAttributeList[record.attrName] = []
                for(let item of record.valueList){
                  formAttributeList[record.attrName].push(item.valueId ? item.valueId: '')
                }
              }
            }else {
              if(typeof(formAttributeList[record.attrName]) == 'string'){
                  formAttributeList[record.attrName] = ''
              }else {
                  formAttributeList[record.attrName] = []
              }
            }
          }
        }

        this.formAttributeList = formAttributeList
        this.$nextTick(()=>{
          this.attributeList = response.data.attribute_list
        })
      }
      this.endLoading()
    },

    handleDown(index){
      let table = this._.clone(this.basicForm.attrList)
      if(index == this.basicForm.attrList.length - 1){
        return
      }
      let object = table[index + 1]
      table[index + 1] = table[index]
      table[index] = object
      this.basicForm.attrList = table
    },
    dataFilter(node, val) {
      if (!!~node.text.indexOf(val) || !!~node.text.toUpperCase().indexOf(val.toUpperCase())) {
        return true
      }
    },
    handleDelete(index){
      let table = this._.clone(this.dataOptional)
      delete this.formOptional[this.dataOptional[index].attrId]
      table.splice(index, 1)
      this.dataOptional = table
    },
    handleCommand(index){
      let data = this._.clone(this.attrList[index])
      if(data.dataType == '08'){
        data.imageGroup = []
      }
      this.formOptional[this.attrList[index].attrId] = this.attrList[index].attrDefaultValue
      this.dataOptional.push(data)
      this.formOptional = this._.clone(this.formOptional)
    },
    handleClose() {
       this.dialogVisible = false
      },
    handleAddAttr(){
      this.$refs['form'].validate((valid)=>{
        if(valid){
          if(this.editIndex == -1){
            this.basicForm.attrList.push(
            this._.clone(this.form))
          } else{
            this.basicForm.attrList[this.editIndex] = this._.clone(this.form)
          }
          this.basicForm = JSON.parse(JSON.stringify(this.basicForm))
          this.dialogVisible = false
        }
      })
    },
    async getTemplate(templateId){
      if(templateId){
        let result = await getTemplateInfo(templateId)
        if(!result.data.saleForm){
          result.data.saleForm = '01'
        }
        this.basicForm = result.data
        this.processData(result.data.attrList)

        this.initPicSizeConfig()
      }
    },
    initPicSizeConfig(){
        if(this.basicForm.picSizeW && this.basicForm.picSizeH ){
          if(this.basicForm.picSizeW == 1600 && this.basicForm.picSizeH  == 1600){
            this.sizeConfig = 1600
          } else if(this.basicForm.picSizeW == 800 && this.basicForm.picSizeH  == 800){
            this.sizeConfig = 800
          }else if(this.basicForm.picSizeW == 1200 && this.basicForm.picSizeH  == 1200){
            this.sizeConfig = 1200
          }else if(this.basicForm.picSizeW == 2000 && this.basicForm.picSizeH  == 2000){
            this.sizeConfig = 2000
          } else{
            this.sizeConfig = 0
            this.picSizeW = this.basicForm.picSizeW
            this.picSizeH = this.basicForm.picSizeH
          }
        } else {
          this.sizeConfig = 800
          this.basicForm.picSizeW = 800
          this.basicForm.picSizeH = 800
        }

    },
    getPathById(value, arr) {
      const tempPath = []
      try {
        for (let i = 0; i < arr.length; i++) {
          this.getNodePath(arr[i], tempPath, value)
        }
      } catch (e) {
        return tempPath
      }
    },
    getNodePath(node, tempPath, value) {
      tempPath.push(node.id)
      if (node.id == value) throw new Error('got it')
      if (node.child && node.child.length > 0) {
        for (let i = 0; i < node.child.length; i++) this.getNodePath(node.child[i], tempPath, value)
        tempPath.pop()
      } else {
        tempPath.pop()
      }
    },

    getPathByIdLazada(value, arr) {
      const tempPath = []
      try {
        for (let i = 0; i < arr.length; i++) {
          this.getNodePathLazada(arr[i], tempPath, value)
        }
      } catch (e) {
        return tempPath
      }
    },
    getNodePathLazada(node, tempPath, value) {
      tempPath.push(node.category_id)
      if (node.category_id == value) throw new Error('got it')
      if (node.children && node.children.length > 0) {
        for (let i = 0; i < node.children.length; i++) this.getNodePathLazada(node.children[i], tempPath, value)
        tempPath.pop()
      } else {
        tempPath.pop()
      }
    },



    handleAddSample(item, record, type){
      item.imageGroup.push({
        imageUrl: record,
        isMain: this.imageGroup.length === 0 ? true : false
      })
      item.attrValue = record

      if(type == '1'){
        this.formRequire[item.attrId] = record
      }else {
        this.formOptional[item.attrId] = record
      }
      this.formRequire = JSON.parse(JSON.stringify(this.formRequire))
      this.formOptional = JSON.parse(JSON.stringify(this.formOptional))
    },
    handleAddSampleDesc(item, record){
      this.editor.insertHtml(`<p style="margin: 0px; display: block; width: 100%; text-align: left;">{image${record}}</p> `);
    },
    handleDeleteImage(item){
      item.imageGroup = []
      item.attrValue = ''
      if(this.formRequire[item.attrId]){
        this.formRequire[item.attrId] = ''
      }
      if(this.formOptional[item.attrId]){
        this.formOptional[item.attrId] = ''
      }
      this.formRequire = JSON.parse(JSON.stringify(this.formRequire))
      this.formOptional = JSON.parse(JSON.stringify(this.formOptional))
    },
 },
 async mounted() {
   let platNo  = this.$route.query.platNo
   let upload =  this.$route.query.upload
   let platName = this.$route.query.platName
   let remitId = this.$route.query.remitId
   this.upload = upload
   this.platName = platName
   this.platNo = platNo
   this.remitId = remitId
   this.getOssToken()
   this.getConfigKey()
   this.getVarList()
   this.getRank()
   let templateId = this.$route.query.templateId || this.templateId
   if(remitId){
    this.basicForm = this.remitData
    this.designIdRemit = this.remitData.designId
    await this.getValues()
    await this.processData(this.remitData.attrList)
    this.initPicSizeConfig()
    this.handleChangeCategory()
    this.handleChangeLazadaCategory()
    this.handleChangeShopeeCategory()
    let mainPicColorOptions = []
    let colors = []
    let result = await getSkuList({ designId: this.designIdRemit })
    for(let record of result.rows[0].skuList){
      if(!colors.includes(record.color)){
        colors.push(record.color)
        mainPicColorOptions.push({
          sysName: record.color
        })
      }
    }
    this.mainPicColorOptions = mainPicColorOptions
   } else if(!templateId){
    this.loadData()
    await this.listDefault()
   } else {
    // this.getTemplate(templateId)
    this.loadData(templateId)
   }
   if(this.platNo == '09' && templateId){
     let result =  await listDefault({platNo: this.platNo})
     this.attrList = result.rows
   }
  },
};
</script>

<style lang="scss" scoped>
.main {
  background: #ffffff;
  padding: 16px;
  box-sizing: border-box;
  .title {
    border-left: 4px solid #4934b2;
    padding-left: 15px;
    font-size: 16px;
    margin-bottom: 30px;
  }
  .check-list {
    margin: 0 0 16px 0;
  }
  ::v-deep .el-form-item__content {
    width: 720px;
  }
  .form-title {
    line-height: 40px;
    font-size: 16px;
  }
  .form-control {
    float: left;
    width: 500px;
  }
  .form-remark {
    float: left;
    color: #606266;
  }
  .image-hint {
    color: #606266;
  }
  li.sort-img-item {
    background: #eeeeee;
    img {
      width: 100px;
      height: 100px;
      position: absolute;
      left: 0;
    }
  }

  .extra-image-ul > div > li {
    width: 100px;
    height: 100px;
    margin-right: 8px;
    margin-bottom: 8px;
    border: 1px solid rgb(221, 221, 221);
    position: relative;
    text-align: center;
    display: inline-block;
  }
  .extra-image-ul > li {
    width: 100px;
    height: 100px;
    margin-right: 8px;
    margin-bottom: 8px;
    border: 1px solid rgb(221, 221, 221);
    position: relative;
    text-align: center;
    display: inline-block;
  }
  .extra-image-ul > div > li > p {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    line-height: 1.4;
    width: 110%;
  }
  li.add-image-button > p {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    line-height: 1.4;
    width: 110%;
  }
  .detail-image-ul.amazon > div > li .wish-product-img-ope,
  .detail-image-ul.lazada > div > li .wish-product-img-ope,
  .wish-product-img > div > li .wish-product-img-ope {
    width: calc(100% - 8px);
    padding: 1px 4px;
    background: rgb(73, 52, 178);
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 9;
    line-height: 20px;
    text-align: left;
    font-size: 12px;
    .set-main {
      float: left;
      cursor: pointer;
    }
    .set-delete {
      float: right;
      cursor: pointer;
    }
  }
  .detail-image-ul.amazon > div > li .wish-product-img-ope > a,
  .detail-image-ul.lazada > div > li .wish-product-img-ope > a,
  .wish-product-img > div > li .wish-product-img-ope > a {
    color: #fff;
  }
  .item-badge {
    position: absolute;
    color: #4934b2;
    font-weight: bold;
    font-size: 14px;
    bottom: -8px;
    right: 6px;
    // -ms-transform: rotate(-35deg);
    // -webkit-transform: rotate(-35deg);
    // transform: rotate(-35deg);
    -webkit-transition: 0 0.1s ease-in;
    -moz-transition: 0 0.1s ease-in;
    -o-transition: 0 0.1s ease-in;
    transition: transform 0.1s ease-in;
    z-index: 1;
    cursor: pointer;
  }
  .add-image-button {
    font-size: 24px;
    vertical-align: 15px;
    position: relative;
  }
  .add-image-button:hover .variable-select-box {
    display: block;
  }
  .variable-select-box {
    position: absolute;
    top: 0;
    left: 100px;
    z-index: 999999;
    background: #fff;
    border: 1px solid rgb(225, 227, 229);
    border-radius: 4px;
    font-size: 12px;
    display: none;
  }

  .variable-select-box li {
    height: 28px;
    line-height: 28px;
    padding: 0 15px;
    cursor: pointer;
    position: relative;
    white-space: nowrap;
  }
  .variable-select-box > ul > li:hover {
    background: #4934b2;
    color: #fff;
  }
  .variable-select-box > ul > li:hover .variable-pick-ul {
    display: block;
  }

  .variable-pick-ul {
    position: absolute;
    top: -1px;
    left: 76px;
    background: #fff;
    border: 1px solid rgb(225, 227, 229);
    border-radius: 4px;
    z-index: 10;
    display: none;
  }
  .variable-pick-ul li:hover {
    background: #4934b2;
    color: #fff;
  }
  .variable-pick-ul li {
    color: #000;
    white-space: nowrap;
  }
}
.insert-link {
  color: #4934b2;
  display: inline-block;
  width: 66px;
  .variable-select-menu {
    position: absolute;
    top: 10px;
    left: 58px;
    z-index: 999999;
    background: #fff;
    border: 1px solid rgb(225, 227, 229);
    border-radius: 4px;
    font-size: 12px;
    display: none;
  }

  .variable-select-menu li {
    height: 28px;
    line-height: 28px;
    padding: 0 15px;
    cursor: pointer;
    position: relative;
    white-space: nowrap;
  }
  .variable-select-menu > ul > li:hover {
    background: #4934b2;
    color: #fff;
  }
  .variable-select-menu > ul > li:hover .variable-pick-ul {
    display: block;
  }
}
.insert-link:hover .variable-select-menu {
  display: block;
}
.variable-select-box-text {
  color: #333333;
}
.sidebar__style {
  width: 160px;
  box-sizing: border-box;
  height: 100px;
  position: fixed;
  top: 150px;
  right: 0px;
  font-size: 14px;
}
.list__style {
  margin-bottom: 20px;
}
.list__style > div {
  border-left: 2px solid #4934b2;
  padding-left: 10px;
  margin-top: 15px;
  cursor: pointer;
}
.button__style {
  border-radius: 5px;
  font-size: 14px;
  line-height: 16px;
  width: 45px;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-bottom: 10px;
  border: 1px solid #999;
}
.submit__style {
  border: 1px solid #4934b2;
  color: #fff;
  background-color: #4934b2;
}
.text-link {
  color: #333;
}
.text-link:visited,
.text-link:hover {
  color: #333;
}
.form-label {
  display: inline-block;
  position: relative;
  line-height: 20px;
}
.field-name {
  position: absolute;
  left: 8px;
  text-align: right;
  top: 40px;
  line-height: 20px;
  color: #aaaaaa;
}
.com-search-input {
  height: 28px;
  border: 1px solid rgb(225, 227, 229);
  vertical-align: top;
}
select {
  color: rgb(89, 90, 90);
  border-radius: 4px;
  width: 100%;
}

input:focus,
textarea:focus,
select:focus,
textarea:focus {
  border: 1px solid #4934b2;
  box-shadow: 0 0 2px #a3c3f9;
  outline: none;
}
.w70 {
  width: 70% !important;
}
.w100 {
  width: 100% !important;
}
.imgSize-box {
  background: #fff;
  border: 1px solid rgb(221, 221, 221);
  min-width: 160px;
  p {
    padding: 7px 10px;
    font-size: 12px;
    line-height: 26px;
  }
  .ml5 {
    margin-left: 5px !important;
  }
}
.editor {
  width: 800px;
}

.main .add-image-button-editor:hover .variable-select-box {
  display: block;
}
.main .add-image-button-editor .variable-select-box {
  left: 60px;
}
.main .add-image-button-editor .variable-pick-ul {
  display: block;
  left: -4px;
  top: 6px;
}
.category-inputs {
  width: 1200px;
}
.category-inputs ::v-deep .el-form-item__content {
  width: 400px !important;
}
.basic ::v-deep .el-form-item__content {
  width: 720px;
}
.main ::v-deep .el-form-item__content {
  width: 720px;
}
</style>
